import React, { useEffect, useState, useContext } from "react";
import classes from "./FreightMaster.module.css";
//import Autocomplete from "./UploadExcel/AutoComplete/AutoComplete";
import Autocomplete from "../../../Shared/AutosuggestV2/Autosuggestv2";
import { toast } from "react-toastify";
import { Urls } from "../../../../Urls";
import axios from "../../../../Axios";
import Modal from "../../../Shared/PopupModal/PopupModal";
import Autosuggestor from "./UploadExcel/AutoComplete/AutoCompleteTransporter";
import Select from "react-select/creatable";
import Loader from "../../../Loader";
import mixpanel from "mixpanel-browser";
import {
  Activity,
  isMobile,
  currentRequestTimeStamp,
} from "../../../../Constants";
import ProfileModal from "../../../TransporterClientScreen/ProfileModal/ProfileModal";
import UploadExcel from "./UploadExcel/UploadExcel";
import { UserApiContext } from "../../../UserDetailsContext/UserDetailsContext";
import {
  MastersChangeLog,
  findObjectDifferences,
  getCommonKeys,
} from "../../Utility";
import Pagination from "react-js-pagination";
import { addTotalTruckAllocation } from "../../../../Utility";
import DownloadMastersButton from "../Utility/DownloadMastersButton";
import { MyCompanyProfileContext } from "../../../../MyCompanyProfileContext";
import { EditableEmailsContext } from "../../../../Context/EditableEmailsContext";
import { sendMailToMasters } from "../Utility/utility";
import { useMixPanelForTracking } from "../../../../utils/TrackMixPanel";
import MultiSelectFilterUI from "../../../Shared/newfilterui/MultiSelectFilterUI";
import ShowHistory from "../../../Planning/components/ShowHistory";
import DownloadLogs from "../DownloadLogs/DownloadLogs";


/**
* @param {String} UserInput - user input
* @param {Function} handleChange - function to trigger on handle change
* @returns {JSX.Element}
*
* TODO : clean and optimize this code
*/
const FreightMaster = ({ UserInput, handleChange, canedit = true, selectedOrg, canAccess, canUpdate, checkActionPermission, onViewMap }) => {
  const [freightData, setfreightData] = useState([]);
  // const [transporter_list, settransporter_list] = useState([])
  // const [shortlisted_transporters, setshortlisted_transporters] = useState([])
  const [TruckTypes, setTruckTypes] = useState([]);
  // const [tableHeaders, settableHeaders] = useState([])
  // const [newLane, setnewLane] = useState(false)
  const [newInputOrigin, setnewInputOrigin] = useState([{}]);
  const [newInputOriginText, setnewInputOriginText] = useState([]);
  const [newInputDestination, setnewInputDestination] = useState([{}]);
  const [newInputDestinationText, setnewInputDestinationText] = useState([]);
  const [newinputTrucks, setnewinputTrucks] = useState([]);
  const [newInput, setnewInput] = useState([]);
  const [isEdit, setisEdit] = useState(false);
  // const [isEdit, setisEdit] = useState(true)
  const [dump_ids, setdump_ids] = useState([]);
  const [show, setshow] = useState(false);
  const [deletion_list, setDeletion_list] = useState([]);
  const { companyProfile } = useContext(UserApiContext);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const [remark, setRemark] = useState("");
  // const [superAdmin , setSuperAdmin] = useState(false)
  const [skipactive, setSkipactive] = useState(0);
  const [totalcount, settotalcount] = useState(0);
  const [superAdmins, setSuperAdmin] = useState([])
  const [emailTemplate, setEmailTemplate] = useState({
    from: '',
    content: '',
    subject: '',
    cc: [],
    description: ''
  })

  const emailData = useContext(EditableEmailsContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [filterPayload, setFilterPayload] = useState(null);
  const [filtersshown, setfiltershown] = useState(false);

  const DEFAULT_SORT_OPTIONS = [
    { value: 'created_on', label: 'Created Date' },
    { value: 'origin_city', label: 'Origin' },
    { value: 'destination', label: 'Destination' },
    { value: 'volume', label: 'Volume' },
    { value: 'baseline_rate', label: 'Baseline Rate' }
  ];

  useEffect(() => {
    if (emailData && emailData?.notifyEmailForMastersUpdate) {
      setEmailTemplate({
        content: emailData?.notifyEmailForMastersUpdate?.content,
        subject: emailData?.notifyEmailForMastersUpdate?.subject,
        cc: emailData?.notifyEmailForMastersUpdate?.cc || "connect@logisticsnow.in",
        from: emailData?.notifyEmailForMastersUpdate?.from,
        description: emailData?.notifyEmailForMastersUpdate?.email_description
      })
    }
  }, [emailData])

  useEffect(() => {
    if (companySettingData && companySettingData?.contact_information && companySettingData?.contact_information?.length > 0) {
      const superAdminEmails = companySettingData?.contact_information?.filter((t) => t?.super_admin === true)?.map((m) => {
        return {
          name: m?.name,
          email: m?.email
        }
      })
      if (superAdminEmails && superAdminEmails?.length > 0) {
        setSuperAdmin(superAdminEmails)
      } else {
        setSuperAdmin([])
      }
    } else {
      setSuperAdmin([])
    }
  }, [companySettingData])

  // useeffect to fetch truck, freight data.
  useEffect(() => {
    if (companyProfile?.domain_data?.company_id) {
      setshow(true);
      getTruckTypes();
      getFreightData(skipactive);

      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight master",
        Definition: "freight master screen viewed",
        Data: `initial skip: ${skipactive}`,
      });
    }
  }, [companyProfile?.domain_data?.company_id]);

  /**
   * Fetches freight data and updates the state with retrieved data.
   * @returns {void}
   */
  const getFreightData = (skips) => {
    setshow(true);
    const payload = {
      resource: "freight_master",
      date_range: [],
      filtersOperator: "and",
      filters: [],
      sort: {
        key: "created_on",
        order: "desc"
      },
      pagination: {
        skip: skips,
        limit: 500
      },
      company_id: companyProfile?.domain_data?.company_id,
    };
    axios
      .post(`${Urls.freight_master}?action=fetch_freight_page`, payload)
      .then((res) => {
        var list = [];
        // res.data.data.map(item => {
        res.data.lane.map((item) => {
          list.push(item?.transporter_details?.length);
          item.transporter_details.map((item, index) => {
            if (typeof item.rank === "number" || item.rank === "") {
              item.rank = `L${index + 1}`;
            }
          });
        });
        settotalcount(res.data.lane_count);
        // console.log(res.data.data, 'res')
        setfreightData(res.data.lane);
        // console.log(Math.max(...list))
        var counter = Math.max(...list);
        var data = [];
        for (var i = 0; i < counter; i++) {
          data.push({
            rank: `L${i + 1} Transporter`,
            rate: `L${i + 1} Rate`,
            share: `L${i + 1} % Business Share`,
          });
        }
        // settableHeaders(data)
        setshow(false);
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
      });
  };

  /**
   * Refreshes the data based on current filter state
   */
  const refreshData = () => {
    if (isFilterActive && filterPayload) {
      handleFilterApply(filterPayload);
    } else {
      const calculatedSkip = skipactive === 0 ? 0 : (skipactive - 1) * 500;
      getFreightData(calculatedSkip);
    }
  };

  /**
   * Handle filter application
   * @param {Object} payload - Filter payload generated by MultiSelectFilterUI
   */
  const handleFilterApply = (payload, showToast = true) => {
    setIsFilterLoading(true);
    setIsFilterActive(true);
    setFilterPayload(payload);

    if (payload?.pagination?.skip === 0) {
      setSkipactive(0);
    }

    setshow(true);
    if (!payload.company_id) {
      payload.company_id = companyProfile?.domain_data?.company_id;
    }

    axios
      .post(`${Urls.freight_master}?action=fetch_freight_page`, payload)
      .then((res) => {
        settotalcount(res.data.lane_count);
        setfreightData(res.data.lane);
        setshow(false);
        setIsFilterLoading(false);
        if (showToast) {
          toast.success(`Found ${res.data.lane_count} results`);
        }
      })
      .catch((err) => {
        console.log(err);
        setshow(false);
        setIsFilterLoading(false);
        toast.error("Failed to apply filters");
      });
  };

  /**
   * Handle filter reset
   */
  const handleFilterReset = () => {
    setIsFilterActive(false);
    setFilterPayload(null);
    setSkipactive(0);
    getFreightData(0);
    toast.info("Filters reset");
  };

  /**
   * Component to display active filters as chips/pills
   */
  const ActiveFilterPills = () => {
    if (!isFilterActive || !filterPayload) return null;

    const hasFilters = filterPayload.filters && filterPayload.filters.length > 0;
    const hasSearch = filterPayload.search && filterPayload.search.trim() !== "";

    // Check for active Sort (if different from default)
    const currentSortKey = filterPayload.sort?.key;
    const isDefaultSort = currentSortKey === 'created_on' || !currentSortKey;
    const currentSortLabel = DEFAULT_SORT_OPTIONS.find(o => o.value === currentSortKey)?.label || currentSortKey;
    const hasSort = !isDefaultSort;

    // Check for active Pagination (if different from default limit 500)
    const currentLimit = filterPayload.pagination?.limit;
    const hasPagination = currentLimit && currentLimit !== 500;

    // If nothing is active (filters, search, sort, pagination), don't render
    if (!hasFilters && !hasSearch && !hasSort && !hasPagination) return null;

    const removeFilter = (filterKey) => {
      const updatedFilters = filterPayload.filters.filter(f => f.key !== filterKey);
      if (updatedFilters.length === 0 && (!filterPayload.search || filterPayload.search.trim() === "") && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          filters: updatedFilters,
          pagination: { ...filterPayload.pagination, skip: 0 }
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const clearSearch = () => {
      const updatedPayload = { ...filterPayload, search: "" };
      if ((!updatedPayload.filters || updatedPayload.filters.length === 0) && !hasSort && !hasPagination) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          search: "",
          pagination: { ...filterPayload.pagination, skip: 0 }
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const resetSort = () => {
      const updatedPayload = { ...filterPayload, sort: { key: 'created_on', order: 'desc' } };
      if (!hasFilters && !hasSearch && !hasPagination) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          sort: { key: 'created_on', order: 'desc' },
          pagination: { ...filterPayload.pagination, skip: 0 }
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const resetPagination = () => {
      const updatedPayload = { ...filterPayload, pagination: { ...filterPayload.pagination, limit: 500 } };
      if (!hasFilters && !hasSearch && !hasSort) {
        handleFilterReset();
      } else {
        const updatedPayload = {
          ...filterPayload,
          pagination: { ...filterPayload.pagination, limit: 500, skip: 0 }
        };
        setFilterPayload(updatedPayload);
        handleFilterApply(updatedPayload);
      }
    };

    const formatValue = (value) => {
      if (Array.isArray(value)) {
        return value.join(", ");
      }
      return value;
    };

    return (
      <div className="active-filters-area mb-3 rounded" style={{
        backgroundColor: '#f8f9fa',
        border: '1px solid #e9ecef',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '8px',
        boxSizing: 'border-box',
        width: '98.4%',
        padding: '8px 12px',
        maxWidth: '100%',
        overflow: 'hidden'
      }}>
        <div className="d-flex align-items-center mr-2" style={{ borderRight: '1px solid #dee2e6', paddingRight: '12px' }}>
          <i className="fa fa-filter mr-2 text-primary" style={{ fontSize: '14px' }} />
          <span className="text-uppercase font-weight-bold text-muted" style={{ fontSize: '10px', letterSpacing: '1px', whiteSpace: 'nowrap' }}>
            Active Filters
          </span>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', flex: '1', alignItems: 'center', minWidth: 0 }}>
          {hasSearch && (
            <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1" style={{ border: '1px solid #3399cc !important' }}>
              <span style={{ fontSize: '12px', color: '#444' }}>
                <i className="fa fa-search mr-1 text-info" style={{ fontSize: '10px' }} />
                <strong className="mr-1">Search:</strong> {filterPayload.search}
              </span>
              <i
                className="fa fa-times ml-2 cursor-pointer text-danger"
                onClick={clearSearch}
                style={{ cursor: 'pointer', fontSize: '12px' }}
              />
            </div>
          )}

          {filterPayload.filters?.map((f, i) => (
            <div key={`${f.key}_${i}`} className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1" style={{ border: '1px solid #7cb342 !important' }}>
              <span style={{ fontSize: '12px', color: '#444' }}>
                <i className="fa fa-check-circle mr-1 text-success" style={{ fontSize: '10px' }} />
                <strong className="mr-1">{f.label || f.key}:</strong> {formatValue(f.values)}
              </span>
              <i
                className="fa fa-times ml-2 cursor-pointer text-danger"
                onClick={() => removeFilter(f.key)}
                style={{ cursor: 'pointer', fontSize: '12px' }}
              />
            </div>
          ))}

          {hasSort && (
            <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1" style={{ border: '1px solid #f0ad4e !important' }}>
              <span style={{ fontSize: '12px', color: '#444' }}>
                <i className="fa fa-sort mr-1 text-warning" style={{ fontSize: '10px' }} />
                <strong className="mr-1">Sort:</strong> {currentSortLabel}
              </span>
              <i
                className="fa fa-times ml-2 cursor-pointer text-danger"
                onClick={resetSort}
                style={{ cursor: 'pointer', fontSize: '12px' }}
              />
            </div>
          )}

          {hasPagination && (
            <div className="filter-pill d-flex align-items-center bg-white border rounded shadow-sm px-2 py-1" style={{ border: '1px solid #9c27b0 !important' }}>
              <span style={{ fontSize: '12px', color: '#444' }}>
                <i className="fa fa-list-ol mr-1 text-purple" style={{ fontSize: '10px' }} />
                <strong className="mr-1">Limit:</strong> {currentLimit}
              </span>
              <i
                className="fa fa-times ml-2 cursor-pointer text-danger"
                onClick={resetPagination}
                style={{ cursor: 'pointer', fontSize: '12px' }}
              />
            </div>
          )}
        </div>

        <button
          className="btn btn-sm btn-link text-danger"
          onClick={handleFilterReset}
          style={{ fontSize: '12px', fontWeight: 'bold', textDecoration: 'none', padding: '4px 8px', whiteSpace: 'nowrap', marginLeft: '8px' }}
        >
          Clear All
        </button>
      </div>
    );
  };

  /**
   * Fetches truck types from the API and updates the state with the retrieved truck types.
   * @returns {void}
   */
  const getTruckTypes = () => {
    axios
      .get(`${Urls.Autocomplete.Get.getlist}?searchFields=truck&include_company_trucks=true`)
      .then((res) => {
        var myTrucks = [];
        var otherTrucks = [];
        res.data.forEach((item) => {
          if (item.name) {
            if (item.from_truck_master) {
              myTrucks.push({ label: item.name, value: item.name, isMyTruck: true });
            } else {
              otherTrucks.push({ label: item.name, value: item.name, isMyTruck: false });
            }
          }
        });
        setTruckTypes([
          { label: "My trucks", options: myTrucks },
          { label: "Other Trucks", options: otherTrucks },
        ]);
      })
      .catch((err) => {
        setshow(false);
      });
  };

  /**
   * Handles selection of all lanes for deletion
   * @param {Event} e - event for select button
   * @returns {void}
   */
  const selectAllHandler = (e) => {
    // setDeletion_list([])
    if (e.target.checked) {
      var list = deletion_list.slice();
      if (freightData && freightData.length > 0) {
        freightData.map((item) => {
          // if(!deletion_list.includes(item)){
          if (
            !deletion_list.some(
              (deleteItem) => deleteItem.freightid === item.freightid
            )
          ) {
            list.push(item);
          }
        });
        setDeletion_list(list);
      }
      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight Master",
        Definition: "user selected all lanes for deletion",
        Data: `selected count: ${list.length}`,
      });
    } else {
      if (deletion_list.length > 0) {
        TrackMixPanel({
          ModuleName: "masters",
          ScreenName: "freight Master",
          Definition: "user deselected all lanes for deletion",
          Data: `deselected count: ${deletion_list.length}`,
        });
      }
      setDeletion_list([]);
    }
  };

  /**
   * function to handle individual checkbox for deletion
   * @param {Event} e - Event for select button
   * @param {Object} item - object for selected lane
   * @returns {void}
   */
  const checkboxeshandler = (e, item) => {
    if (e.target.checked) {
      var list = deletion_list.slice();
      list.push(item);
      // console.log(list)
      setDeletion_list(list);

      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight Master",
        Definition: "user selected a lane for deletion",
        Data: `lane id: ${item.freightid}, origin: ${item.origin}, destination: ${item.destination}`,
      });
    } else {
      var temp = deletion_list.filter(
        (value) => value.freightid !== item.freightid
      );
      // console.log(temp)
      setDeletion_list(temp);

      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight Master",
        Definition: "user deselected a lane for deletion",
        Data: `lane id: ${item.freightid}, origin: ${item.origin}, destination: ${item.destination}`,
      });
    }
  };

  /**
   * deletes selected lanes via API call
   * @param {Event} e - event for deleted button
   * @param {any} item - items selected for deletion
   * @returns {void}
   */
  const deleteLanes = (e, item) => {
    if (window.confirm("Are you sure you want to delete lane/s?")) {
      const deletedLanesData = deletion_list.map(l => l.freightid).join(', ');
      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "freight Master",
        Definition: "user clicked on freight master bulk delete button",
        Data: `lanes deleted: ${deletedLanesData}, count: ${deletion_list.length}`,
      });

      const payload = {
        freightids: deletion_list?.length > 0 && deletion_list?.map((items) => {
          return items.freightid;
        }),
      };
      const activity = deletion_list?.length > 0 && deletion_list?.map((i) => {
        return { freightid: i?.freightid, laneid: i?.laneid }
      })
      axios
        .put(`${Urls.freight_master}?action=deleted_multiple_freight`, payload)
        .then(() => {
          toast.success("Lanes deleted successfully");
          sendMailToMasters(
            "Freight Master",
            emailTemplate,
            superAdmins,
            {
              action: `Multiple Item(s) Deleted`,
              lane: '',
            },
            setshow,
            userDetails?.user_name || userDetails?.email?.split("@")[0]
          );
          refreshData();
          setDeletion_list([]);
          MastersChangeLog(
            "Line Item Deleted",
            "freight_master",
            userDetails?.email,
            userDetails?.user_id,
            companyProfile?.domain_data?.company_id,
            activity,
            remark
          );
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    }
  };

  /**
    * deletes a single lane
    * @param {Event} e - event for delete button click
    * @param {Object} item - object of lane details
    * @returns {void}
    */
  const deleteLane = (e, item) => {
    if (isEdit) {
      setshow(true);
      axios
        .put(
          `${Urls.freight_master}?action=deleted_freight_rate&freightid=${item.freightid}`,
          {}
        )
        .then((res) => {
          toast.success("Lane deleted successfully");
          axios.get(`${Urls.freight_master}`)
            .then(res => {
              setnewInput(res.data.data)
            })
            .catch(err => {
              console.log(err)
            })
          setshow(false);
          window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          setshow(false);
        });
    } else {
      var temp = newInput;
      var list = [];
      // console.log(temp)
      // console.log(item)
      if (temp && temp.length > 0) {
        temp.map((data) => {
          if (
            data.origin.location_name !== item.origin.location_name &&
            data.destination.location_name !== item.destination.location_name &&
            data.transit_time !== item.transit_time &&
            data.baseline_rate !== item.baseline_rate &&
            data.volume !== item.volume
          ) {
            list.push(data);
          }
        });
      }
      setnewInput(list);
      // console.log(list)
      // // console.log(freightData)
    }
  };

  /**
   * Handles changes in input fields for the lane.
   * @param {string} e - New value for the input field.
   * @param {Object} item - lane object to update.
   * @param {string} key - key in the lane object to update.
   * @param {Array<Object>} allValue - all input values
   * @returns {void}
   */
  const inputHandler = (e, item, key, allValue) => {
    if (!dump_ids.includes(allValue.freightid) && isEdit) {
      setdump_ids([...dump_ids, allValue.freightid]);
    }
    var temp = allValue.transporter_details;
    var list = [];
    if (temp && temp.length > 0) {
      temp.map((item) => {
        list.push(item.transporter.transporter_name);
      });
    }
    if (key === "transporter") {
      if (!list.includes(e.transporter_name)) {
        item[key] = e;
        // TrackMixPanel({
        //   ModuleName: "masters",
        //   ScreenName: "freight master",
        //   Definition: "user updated lane field: transporter",
        //   Data: `lane id: ${allValue.freightid}, new transporter: ${e.transporter_name}`,
        // });
        // ---------------------------------------------------------------
      } else {
        toast.error("Transporter already exists");
        TrackMixPanel({
          ModuleName: "masters",
          ScreenName: "freight master",
          Definition: "transporter addition failed: duplicate entry",
          Data: `lane id: ${allValue.freightid}, attempted transporter: ${e.transporter_name}`,
        });
        // ---------------------------------------------------------------
      }
    } else {
      item[key] = e;
      const trackedKeys = ['transit_time', 'baseline_rate', 'volume', 'origin', 'destination', 'truck_type'];
      if (trackedKeys.includes(key) || key.includes('_rate')) {
        TrackMixPanel({
          ModuleName: "masters",
          ScreenName: "freiight master",
          Definition: `user updated lane field: ${key}`,
          Data: `lane id: ${allValue.freightid}, field: ${key}, new value: ${e}`,
        });
      }
    }
  };

  /**
     * function to add new input for transporter details
     * @param {Event} e - Event for input change
     * @param {Object} item - object for lane details
     * @param {String} key - key for input
     * @returns {void}
     */
  const addnewinputHandler = (e, item, key) => {
    item[key] = e;

    const trackedKeys = ['rate', 'business_share'];
    if (trackedKeys.includes(key) && item?.transporter?.transporter_name) {
      TrackMixPanel({
        moduleName: "masters",
        screenName: "freight master",
        definition: `user updated new lane transporter detail: ${key}`,
        data: `transporter: ${item.transporter.transporter_name}, field: ${key}, new value: ${e}`,
      });
    }
  };

  /**
   * Function  to check if lane exists in freight master via api call
   * @param {Object} lane - lane details
   * @returns {void}
   */
  const laneExists = (lane) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${Urls.freight_master}?action=check_lane`, {
          lanes: [
            {
              origin: lane.origin,
              destination: lane.destination,
              truck_type: lane.truck_type,
            },
          ],
        })
        .then((res) => {
          const exists = res.data.exists.exists === "yes";
          if (exists) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };

  /**
   * AddNewLane Component
   */
  const AddNewLane = () => {
    const [origin, setorigin] = useState({});
    const [inputorigin, setinputorigin] = useState("");
    const [destination, setdestination] = useState({});
    const [inputdestination, setinputdestination] = useState("");
    const [selectedTrucks, setselectedTrucks] = useState([]);
    const [transit_time, settransit_time] = useState(0);
    const [baseline_rate, setbaseline_rate] = useState();
    const [marketRate, setMarketRate] = useState();
    const [siteRate, setSiteRate] = useState();
    const [challengePrice, setChallengePrice] = useState();
    const [volume, setvolume] = useState(0);
    const [distance, setDistance] = useState();
    const [unit, setUnit] = useState("MT");
    const [zone, setZone] = useState("");
    const [route_code, setRoute_code] = useState("");
    const [truckLoad, setTruckLoad] = useState("");
    const [contractTenure, setContractTenure] = useState("");
    const [addnewlane, setAddnewlane] = useState(false);
    const [additionalColumns, setadditionalColumns] = useState([
      {
        rank: `L1`,
        rate: "",
        business_share: "",
        transporter: {
          transporter_name: "",
        },
      },
    ]);
    const [transporter, settransporter] = useState(1);

    /**
     * Submits the new lane information after validation.
     * @param {Event} e - submit event object.
     */
    const submitNewLane = async (e, onClose) => {
      // const sqlInjectionPatterns = /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))/i;
      const sqlInjectionPatterns =
        /(select\s*\*\s*from)|(sleep\s*\(\s*\d+\s*\))|(insert\s+into\s+\w+\s*\([^)]*\)\s*values\s*\([^)]*\))/i;

      TrackMixPanel({
        moduleName: "masters",
        screenName: "freight master",
        definition: "user clicked on submit new lane button",
        data: `attempted origin: ${origin?.location_name || 'none'}, attempted destination: ${destination?.location_name || 'none'}`,
      });

      const isValidNumber = (value) => {
        // Check if value is a non-empty string and matches the number pattern (integer or decimal, with optional negative sign)

        const isValid = /^-?\d+(\.\d+)?$/;
        // Check if the value is not an empty string and matches the regex for valid number

        return !/[a-zA-Z]/.test(value) && isValid?.test(value);
      };
      if (!transit_time) {
        toast.error("Please fill Transit Time");
        return;
      }
      if (marketRate && !isValidNumber(marketRate)) {
        toast.error("Market Rate must be a number");
        return;
      }
      if (siteRate && !isValidNumber(siteRate)) {
        toast.error("Site Rate must be a number");
        return;
      }
      if (challengePrice && !isValidNumber(challengePrice)) {
        toast.error("Challenge Price must be a number");
        return;
      }
      var check_lane = {
        origin: origin,
        destination: destination,
        truck_type: selectedTrucks,
      };
      var lane = {
        origin: origin,
        destination: destination,
        truck_type: selectedTrucks,
        volume: parseInt(volume),
        transit_time: parseInt(transit_time),
        baseline_rate: parseInt(baseline_rate),
        market_rate: parseInt(marketRate),
        site_rate: parseInt(siteRate),
        challenge_price: parseInt(challengePrice),
        unit: unit,
        zone: zone,
        route_code: route_code,
        distance: distance,
        contract_tenure: contractTenure,
        truck_load: truckLoad,

        transporter_details: addTotalTruckAllocation(
          additionalColumns,
          truckLoad
        ),
      };
      if (sqlInjectionPatterns.test(origin)) {
        toast.error("Invalid Origin");
      } else if (sqlInjectionPatterns.test(destination)) {
        toast.error("Invalid Destination");
      } else if (sqlInjectionPatterns.test(volume)) {
        toast.error("Invalid Volume");
      } else if (sqlInjectionPatterns.test(transit_time)) {
        toast.error("Invalid Transit Time");
      } else if (sqlInjectionPatterns.test(truckLoad)) {
        toast.error("Invalid truck load");
      } else if (sqlInjectionPatterns.test(contractTenure)) {
        toast.error("Invalid contact tenure");
      } else if (sqlInjectionPatterns.test(unit)) {
        toast.error("Invalid Unit");
      } else if (sqlInjectionPatterns.test(zone)) {
        toast.error("Invalid Zone");
      } else if (sqlInjectionPatterns.test(route_code)) {
        toast.error("Invalid Route Code");
      } else if (baseline_rate && sqlInjectionPatterns.test(baseline_rate)) {
        toast.error("Invalid Baseline Rate");
      } else if (distance && sqlInjectionPatterns.test(distance)) { // Added null check for distance
        toast.error("Invalid Distance");
      } else if (validateAllFields(lane)) {
        try {
          const isLaneExists = await laneExists(check_lane);

          if (isLaneExists) {
            toast.error("This lane already exists");
          } else {
            // Rest of the code for submitting the lane

            if (validateBusinessShare(lane)) {
              if (isEdit) {
                var list = [];
                var temp = [lane];
                if (temp && temp.length > 0) {
                  temp.map((item) => {
                    if (dump_ids.includes(item.freightid)) {
                      list.push(item);
                    }
                  });
                }
                var lanes = list;
                // console.log(lanes, '321')
                if (isBusinessShareOkay(lanes)) {
                  axios
                    .put(`${Urls.freight_master}?action=edit_freight_master`, {
                      lanes,
                    })
                    .then((res) => {
                      // consol'e.log(res.data)
                      toast.success("Lane submitted succesfully");
                      if (onClose) onClose();
                      setnewInput([]);
                      const calculatedSkip = skipactive === 0 ? 0 : (skipactive - 1) * 500;
                      getFreightData(calculatedSkip);
                      setisEdit(false);
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                  // toast.success("Data submitted")
                } else {
                  toast.error("Total Business Share should be equal to 100%");

                }
              } else {
                lane.transporter_details.map((items) => {
                  items.business_share = parseFloat(items.business_share);
                  items.rate = parseFloat(items.rate);
                });
                var lanes = [lane];
                console.log(lanes, "LANE")
                if (isBusinessShareOkay(lanes)) {
                  // sendMail
                  sendMailToMasters("Freight Master", emailTemplate, superAdmins,
                    {
                      action: "New Lane Added",
                      lane: lanes[0]
                    }
                    , setshow, userDetails?.user_name || userDetails?.email?.split("@")[0])
                  axios
                    .post(`${Urls.freight_master}`, {
                      lanes,
                    })
                    .then((res) => {
                      // console.log(res.data)
                      if (res.data.status === "failed") {
                        const errorMsg = res.data.id?.error || "Failed to submit lane.";
                        toast.error(errorMsg);
                        return;
                      }
                      toast.success("Lane submitted succesfully");
                      if (onClose) onClose();
                      Activity([
                        {
                          screen: "masters",
                          module: "Freight Master",
                          user_activity: `Submit Lane Button Clicked`,
                          timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name,
                          companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
                        },
                      ]);

                      TrackMixPanel({
                        moduleName: "masters",
                        screenName: "freight master",
                        definition: "new lane created successfully",
                        data: `freight id: ${res.data.id}, origin: ${origin?.location_name}, destination: ${destination?.location_name}, truck type: ${selectedTrucks?.value}`,
                      });
                      setnewInput([]);
                      refreshData();
                      var activity = {
                        freightid: res.data.id,
                        laneid: `${lanes[0].origin.location_name}_to_${lanes[0].destination.location_name}`,
                        from: "masters",
                      };
                      MastersChangeLog(
                        "Line Item Added",
                        "freight_master",
                        userDetails?.email,
                        userDetails?.user_id,
                        companyProfile?.domain_data?.company_id,
                        activity,
                        ""
                      );
                    })
                    .catch((err) => {
                      console.log(err);

                    });
                } else {
                  toast.error("Total Business Share should be equal to 100%");
                }
              }
            } else {
              toast.error(
                "Please ensure the total business share is equal to 100%"
              );
            }
          }
        } catch (error) {
          toast.error("Error checking lane existence");
        }
      } else {
        toast.error("Please fill all fields");
        TrackMixPanel({
          moduleName: "masters",
          screenName: "freight master",
          definition: "new lane submission failed: missing required fields",
          data: `origin: ${origin?.location_name}, destination: ${destination?.location_name}, truck_type: ${selectedTrucks?.value}, volume: ${volume}`,
        });
      }
    };

    /**
     * Validates all required fields in the lane object.
     * @param {Object} lane - lane object containing all the lane details.
     * @returns {boolean} True if all fields are valid, false otherwise.
     */
    const validateAllFields = (lane) => {
      // console.log(lane)
      if (
        lane.origin.location_name === undefined ||
        lane.destination.location_name === undefined ||
        lane.truck_type.length === 0 ||
        lane.transit_time === 0
        // || lane.baseline_rate === 0
      ) {
        return false;
      } else {
        return true;
      }
    };

    /**
     * Validates the business share details of the lane.
     * @param {Object} lane - lane object containing transporter details.
     * @returns {boolean} True if business shares are valid, false otherwise.
     */
    const validateBusinessShare = (lane) => {
      var temp = lane.transporter_details;
      var list = [];

      //create a new list to manipulate and check the business share
      if (temp && temp.length > 0) {
        temp.map((item) => {
          list.push(parseInt(item.business_share));
        });
      }

      //check if the business share is in the mulitples of 5
      if (list.every((num) => num % 5 !== 0)) {
        toast.info("Please add business share in multiples of 5!");
        return false;
      }

      // check total business share
      if (list.reduce((a, b) => a + b, 0) !== 100) {
        toast.error("Total Business Share should be equal to 100%");
        return false;
      }

      return true;
    };
    /**
     * Component to manage the transporter details, allowing users to add, edit, or
     * delete transporter rows. It also handles saving transporter details.
     *
     * @param {Object} props - The props object.
     * @param {boolean} props.readOnly - Whether the component is in read-only mode.
     * @returns {JSX.Element} The rendered ViewLsp component.
     */
    const ViewLsp = ({ readOnly, onClose }) => {

      TrackMixPanel({
        moduleName: "masters",
        screenName: "freight master",
        definition: "user clicked on view transporter button",
        data: `None`,
      });
      // --------------------------------------------------------------------

      const [searchText, setSearchText] = useState();
      const [againupdate, setagainupdate] = useState(additionalColumns);
      const [editName, seteditName] = useState();
      const [existingSearchText, setexistingSearchText] = useState();

      const addColumns = (e) => {
        // console.log("add button")

        TrackMixPanel({
          moduleName: "masters",
          screenName: "freight master",
          definition: "user clicked on add transporter button",
          data: `current count: ${additionalColumns.length}`,
        });

        setSearchText("");
        var transporter_value = transporter + 1;
        settransporter(transporter_value);
        var temp = {
          rank: `L${transporter_value}`,
          rate: "",
          business_share: "",
          transporter: {
            transporter_name: "",
          },
        };
        setadditionalColumns([...additionalColumns, temp]);
      };
      const deleteColumns = (e, item) => {
        var temp = additionalColumns;
        var list = [];
        if (temp && temp.length > 0) {
          temp.map((values) => {
            if (values.rank !== item.rank) {
              list.push(values);
            }
          });
        }
        setadditionalColumns(list);
        var transporter_value = transporter - 1;
        settransporter(transporter_value);
      };

      //fields related to auto allocatino are added in the payload
      const saveClick = (e) => {
        var lane = {
          origin: origin,
          destination: destination,
          truck_type: selectedTrucks,
          volume: parseInt(volume),
          transit_time: parseInt(transit_time),
          baseline_rate: parseInt(baseline_rate),
          unit: unit,
          distance_in_km: distance,
          zone: zone,
          route_code: route_code,

          /* Auto Allocation specific fields */
          transporter_details: addTotalTruckAllocation(againupdate, truckLoad),
          contract_tenure: contractTenure,
          truck_load: truckLoad,
        };
        var transporterName =
          againupdate && againupdate.length > 0
            ? againupdate.map((item) => {
              return item.transporter.transporter_name;
            })
            : "No";
        if (validateBusinessShare(lane)) {
          toast.success("Transporter details added");

          TrackMixPanel({
            moduleName: "masters",
            screenName: "freight master",
            definition: "user saved transporter details",
            data: `transporters added: ${transporterName}`,
          });

          if (onClose) {
            onClose();
          } else {
            document.getElementById("closebutton")?.click();
          }
        }
      };

      const editTransporterName = (e, index) => {
        seteditName(index);
      };

      const againupdateHandler = (e, item, key) => {
        // console.log(e)
        if (!dump_ids.includes(item.freightid) && isEdit) {
          setdump_ids([...dump_ids, item.freightid]);
        }
        var temp = [];
        var list = [];
        if (item.transporter_details && item?.transporter_details?.length > 0) {
          temp = item.transporter_details;
          temp.map((i) => {
            list.push(i.transporter.transporter_name);
          });
        }

        if (key === "transporter") {
          if (!list.includes(e.transporter_name)) {
            item[key] = e;
          } else {
            toast.error("Transporter already exists");
          }
        } else {
          item[key] = e;
        }
      };

      return (
        <>
          {againupdate.length > 0 ? (
            <>
              <span>
                Make sure that the % allocation is 100% for the transporters.
              </span>
              <br />
              <br />
              {againupdate.map((item, index) => (
                <>
                  <tr key={index}>
                    <td width="50%">
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>
                          {item.rank} Transporter{" "}
                          {!readOnly && editName !== index ? (
                            <i
                              onClick={(e) => editTransporterName(e, index)}
                              className="fa fa-pencil"
                            />
                          ) : null}
                        </b>
                      </label>
                      <br />
                      <label style={{ width: "90%" }}>
                        {readOnly ? (
                          <>
                            {/* {item.transporter.transporter_name} */}
                            <ProfileModal
                              // transporter_list={dashboard_data.not_quoted_trans_list}
                              transporter_id={item.transporter.transporter_id}
                              transporter_name={
                                item.transporter.transporter_name
                              }
                              screenName="Freight Master"
                              moduleName="Freight Master"
                            />
                          </>
                        ) : item.transporter.transporter_name === "" ? (
                          <Autosuggestor
                            value={searchText}
                            defaultValue={
                              item.transporter.transporter_name !== ""
                                ? item.transporter.transporter_name
                                : searchText
                            }
                            onChange={(e) => setSearchText(e)}
                            onSelect={(e) => setSearchText(e)}
                            getResults={(e) =>
                              againupdateHandler(e, item, "transporter")
                            }
                          />
                        ) : editName !== index ? (
                          <input
                            disabled
                            value={item.transporter.transporter_name}
                          />
                        ) : (
                          <Autosuggestor
                            value={existingSearchText}
                            // placeholder={item.transporter.transporter_name}
                            // defaultValue={item.transporter.transporter_name !== '' ? item.transporter.transporter_name : searchText}
                            onChange={(e) => setexistingSearchText(e)}
                            onSelect={(e) => setexistingSearchText(e)}
                            getResults={(e) =>
                              againupdateHandler(e, item, "transporter")
                            }
                          />
                        )}
                      </label>
                    </td>

                    <td>
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>{item.rank} Rate</b>
                      </label>
                      <br />
                      <label style={{ width: "90%" }}>
                        <input
                          type="number"
                          name="rate"
                          id="rate"
                          onChange={(e) =>
                            addnewinputHandler(e.target.value, item, "rate")
                          }
                          defaultValue={item.rate}
                          onWheel={(e) => e.target.blur()}
                        />
                      </label>
                    </td>

                    <td>
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>{item.rank} % Business Share</b>
                      </label>
                      <br />
                      <label style={{ width: "90%" }}>
                        <input
                          type="number"
                          name="business_share"
                          id="business_share"
                          onChange={(e) =>
                            addnewinputHandler(
                              e.target.value,
                              item,
                              "business_share"
                            )
                          }
                          defaultValue={item.business_share}
                          onWheel={(e) => e.target.blur()}
                        />
                      </label>
                      {index === additionalColumns.length - 1 &&
                        additionalColumns.length !== 1 ? (
                        <i
                          onClick={(e) => deleteColumns(e, item)}
                          style={{ color: "red", cursor: "pointer" }}
                          className="fa fa-times"
                        ></i>
                      ) : null}
                    </td>
                  </tr>
                  <hr />
                </>
              ))}
              <button
                className="btn btn-sm btn-success"
                onClick={(e) => addColumns(e)}
              >
                <i
                  className="fa fa-plus"
                  style={{ cursor: "pointer", color: "white" }}
                ></i>
              </button>
              <button
                className="btn btn-sm btn-success"
                style={{ marginLeft: "43%" }}
                onClick={(e) => saveClick(e)}
              >
                Save
              </button>
            </>
          ) : null}
        </>
      );
    };

    return (
      <div className={`d-flex align-items-center justify-content-between px-2 ${classes.freightMasterHeader}`}>
        {/* Left Side: Management Action Buttons */}
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          {/* Add Freight Master Button */}
          <Modal
            buttonLabel={
              <>
                <i className="fa fa-plus mr-2" />
                Add Freight Master
              </>
            }
            buttonClass="btn btn-primary px-3 py-2 text-nowrap"
            title="Add New Freight Master"
            size="xl"
            dialogClassName={classes["custom-modal-70"]}
            backdrop={false}
            content={({ onClose }) => (
              <div className="container-fluid px-4 py-3">
                {/* ... existing modal content ... */}
                <h6 className="text-secondary font-weight-bold mb-3" style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}>General Information</h6>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Origin <span className="text-danger">*</span></label>
                    <div style={{ height: "40px" }}>
                      <Autocomplete
                        key="Origin_Key"
                        module_key="indents"
                        user_identifier={companyProfile?.domain_data?.company_id}
                        value={
                          inputorigin
                            ? { label: inputorigin, value: inputorigin }
                            : null
                        }
                        placeholder="Origin/Code"
                        onChange={(val) => setinputorigin(val)}
                        onSelect={(obj) => setorigin(obj)}
                        className={classes["originn"]}
                        isDisabled={canedit || !canUpdate}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Origin ID</label>
                    <input
                      value={origin?.location_code || ""}
                      disabled
                      className="form-control"
                      style={{ height: "40px", backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Origin State</label>
                    <input
                      value={origin?.location?.state || ""}
                      disabled
                      className="form-control"
                      style={{ height: "40px", backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Destination <span className="text-danger">*</span></label>
                    <div style={{ height: "40px" }}>
                      <Autocomplete
                        key="Destination_Key"
                        module_key="indents"
                        user_identifier={companyProfile?.domain_data?.company_id}
                        value={
                          inputdestination
                            ? { label: inputdestination, value: inputdestination }
                            : null
                        }
                        placeholder="Destination/Code"
                        onChange={(val) => setinputdestination(val)}
                        onSelect={(obj) => setdestination(obj)}
                        className={classes["originn"]}
                        isDisabled={canedit || !canUpdate}
                      />
                    </div>
                  </div>
                </div>

                {/* Row 2: Location Cont. & Cargo */}
                <div className="row mb-4">
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Destination ID</label>
                    <input
                      value={destination?.location_code || ""}
                      disabled
                      className="form-control"
                      style={{ height: "40px", backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Destination State</label>
                    <input
                      value={destination?.location?.state || ""}
                      disabled
                      className="form-control"
                      style={{ height: "40px", backgroundColor: "#f8f9fa" }}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Truck Types <span className="text-danger">*</span></label>
                    <div style={{ minHeight: "40px" }}>
                      <Select
                        options={TruckTypes}
                        isMulti={false}
                        onChange={(value) => setselectedTrucks(value)}
                        value={selectedTrucks}
                        className={`Truck_Type_Select ${classes["select-truck"]}`}
                        classNamePrefix={"Truck_Prefix"}
                        defaultValue=""
                        isDisabled={canedit || !canUpdate}
                        styles={{ control: (base) => ({ ...base, minHeight: '40px' }) }}
                        formatOptionLabel={(option) => (
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            {option.isMyTruck && (
                              <i className="fa fa-truck" style={{ fontSize: "14px", color: "#393185" }}></i>
                            )}
                            <span>{option.label}</span>
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Volume</label>
                    <input
                      type="number"
                      className="form-control"
                      name="volume"
                      id="volume"
                      style={{ height: "40px" }}
                      onChange={(e) => setvolume(e.target.value)}
                      placeholder=""
                      value={volume > 0 ? volume : ""}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                </div>

                {/* Section 2: Transit & Route Details */}
                <h6 className="text-secondary font-weight-bold mb-3 mt-4" style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}>Transit & Route Details</h6>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Transit Time (Days) <span className="text-danger">*</span></label>
                    <input
                      type="number"
                      className="form-control"
                      name="transit_time"
                      id="transit_time"
                      style={{ height: "40px" }}
                      onChange={(e) => settransit_time(e.target.value)}
                      placeholder="Days"
                      value={transit_time > 0 ? transit_time : ""}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Distance (in Km)</label>
                    <input
                      type="number"
                      className="form-control"
                      name="distance"
                      id="distance"
                      style={{ height: "40px" }}
                      onChange={(e) => setDistance(e.target.value)}
                      value={distance}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Zone</label>
                    <input
                      name="zone"
                      className="form-control"
                      id="zone"
                      style={{ height: "40px" }}
                      onChange={(e) => setZone(e.target.value)}
                      value={zone}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Route Code</label>
                    <input
                      name="route_code"
                      className="form-control"
                      id="routeCode"
                      style={{ height: "40px" }}
                      onChange={(e) => setRoute_code(e.target.value)}
                      value={route_code}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                </div>

                {/* Section 3: Contract & Pricing Details */}
                <h6 className="text-secondary font-weight-bold mb-3 mt-4" style={{ borderBottom: "1px solid #eee", paddingBottom: "8px" }}>Contract & Pricing Details</h6>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Contract Tenure</label>
                    <select
                      className="form-control"
                      style={{ height: "40px" }}
                      onChange={(e) => setContractTenure(e.target.value)}
                      disabled={canedit || !canUpdate}
                    >
                      <option hidden>Select contract tenure</option>
                      <option value="Annual">Annual</option>
                      <option value="Semi-annual">Semi Annual</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Weekly">Weekly</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Truck Loads</label>
                    <input
                      type="number"
                      className="form-control"
                      name="truckLoads"
                      id="truckLoads"
                      style={{ height: "40px" }}
                      onChange={(e) => setTruckLoad(e.target.value)}
                      value={truckLoad}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Baseline Rate</label>
                    <input
                      type="number"
                      className="form-control"
                      name="baselineRate"
                      id="baselineRate"
                      style={{ height: "40px" }}
                      onChange={(e) => setbaseline_rate(e.target.value)}
                      value={baseline_rate}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Market Rate</label>
                    <input
                      name="marketRate"
                      className="form-control"
                      id="marketRate"
                      style={{ height: "40px" }}
                      onChange={(e) => setMarketRate(e.target.value)}
                      value={marketRate}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                </div>

                {/* Row 5: Pricing Cont. */}
                <div className="row mb-4">
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Site Rate</label>
                    <input
                      name="siteRate"
                      className="form-control"
                      id="siteRate"
                      style={{ height: "40px" }}
                      onChange={(e) => setSiteRate(e.target.value)}
                      value={siteRate}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-3">
                    <label className={classes["add-items"]} style={{ minHeight: "38px" }}>Challenge Price</label>
                    <input
                      name="challengePrice"
                      className="form-control"
                      id="challengePrice"
                      style={{ height: "40px" }}
                      onChange={(e) => setChallengePrice(e.target.value)}
                      value={challengePrice}
                      disabled={canedit || !canUpdate}
                    />
                  </div>
                  <div className="col-md-6"></div>
                </div>

                {/* Action Buttons */}
                <div className="d-flex align-items-center justify-content-end mt-5 pt-3 border-top" style={{ gap: "12px" }}>
                  <Modal
                    buttonLabel={<span className="text-primary">Add Transporters Details</span>}
                    buttonClass="btn btn-link p-0 mr-3"
                    disabled={canedit || !canUpdate}
                    content={({ onClose }) => <ViewLsp readOnly={false} onClose={onClose} />}
                    title={`Shortlist Transporters`}
                    id="add_transporters_details_btn"
                    screenName="Company Profile"
                    moduleName="Freight Master"
                    activityName="Freight Master - View Transporters button clicked"
                    backdrop={true}
                  />

                  <button className="btn btn-outline-secondary px-4 py-2" onClick={onClose} style={{ height: "42px" }}>
                    Cancel
                  </button>

                  <button
                    id="add_new_lane"
                    title={"Add lane"}
                    className="btn btn-success px-4 py-2"
                    style={{ height: "42px" }}
                    disabled={canedit || !canUpdate}
                    onClick={(e) => submitNewLane(e, onClose)}
                  >
                    Save <i className="fa fa-save ml-2"></i>
                  </button>
                </div>
              </div>
            )}
          />

          <Modal
            buttonLabel={
              <>
                <i className="fa fa-upload mr-2" />
                Upload
              </>
            }
            buttonClass="btn btn-primary px-3 py-2 text-nowrap"
            disabled={canedit || !canUpdate}
            content={<UploadExcel selectedOrg={selectedOrg} emailTemplate={emailTemplate} superAdmins={superAdmins} />}
            title={`LoRRI Freight Master`}
            id="upload_freight_master_btn"
            screenName="masters"
            moduleName="Freight Master"
            activityName="Freight Master - View Transporters button clicked"
            closeButtonId="close_contactus1"
          />
          <DownloadMastersButton
            type={"freight"}
            company_id={companyProfile?.domain_data?.company_id}
            masterList={freightData}
            totalCount={totalcount}
          />
          <button
            id="submitLane"
            className={`btn btn-danger px-3 py-2 text-nowrap`}
            disabled={deletion_list.length === 0 || canedit || !canUpdate}
            onClick={(e) => deleteLanes(e)}
          >
            <i className={`fa fa-trash mr-2`} />
            Delete
          </button>

          <button
            className={`btn ${isFilterActive ? 'btn-success' : 'btn-primary'} px-3 py-2 text-nowrap`}
            onClick={() => setfiltershown(!filtersshown)}
            title={isFilterActive ? "Filters are active" : "Advanced Filters"}
          >
            <i className={`fa ${isFilterActive ? 'fa-check-circle' : 'fa-filter'} mr-2`} />
            {isFilterActive ? "Filters Applied" : "Filter"}
          </button>
        </div>

        {/* Right Side: Utility Action Buttons */}
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <button className={`btn btn-success px-3 py-2 text-nowrap`} onClick={onViewMap}>
            <i className="fa fa-map mr-2" />
            View Map
          </button>
          <Modal
            id="upload-modal"
            buttonLabel={
              <>
                <i className="far fa-clock mr-2" />
                Show Activity
              </>
            }
            buttonClass={`btn btn-info px-3 py-2 text-nowrap`}
            disabled={!canUpdate}
            content={<ShowHistory screen_name='freight_master' />}
            screenName="Freight Master"
            moduleName="Masters"
            title="Activity History"
          />
          <Modal
            id="upload-modal-logs"
            buttonLabel={
              <>
                <i className='fa fa-download mr-2' />
                Download Logs
              </>
            }
            buttonClass={`btn btn-primary px-3 py-2 text-nowrap`}
            disabled={!canUpdate}
            content={<DownloadLogs />}
            screenName="Freight Master"
            moduleName="Masters"
            title='Download Logs For Freight Master'
          />
        </div>
      </div>
    );
  };

  /**
   * Component displays the details of LSP for a freight lane.
   * @param {boolean} readOnly - whether the component is in read-only mode.
   * @param {Object} data - data for the LSP details.
   * @param {Object} FreightItem - freight item object.
   * @param {Object} allValue - Additional data used for autocomplete.
   * @returns {JSX.Element}
   */
  const ViewLspDetails = ({ allValue, readOnly, data, FreightItem, onClose }) => {
    const [searchText, setSearchText] = useState();
    const [editName, seteditName] = useState();
    const [existingSearchText, setexistingSearchText] = useState();
    const [transporter, settransporter] = useState(1);
    const [note, setnote] = useState(0);
    const [showNote, setshowNote] = useState(false);

    // useefect to process iniital data for inputs
    useEffect(() => {
      var temp = data;
      var list = [];
      // if(temp && temp.length > 0){
      // temp.map(item => {
      //     list.push(parseInt(item.business_share))
      // })
      // }
      if (temp && temp.length > 0) {
        list = temp.map((item) => {
          const parsedValue = parseInt(item.business_share);
          if (!isNaN(parsedValue)) {
            return parsedValue;
          } else {
            setnote(0);
            return 0;
          }
        });
      }
      if (!(list.reduce((a, b) => a + b, 0) === 100)) {
        setnote(list.reduce((a, b) => a + b, 0));
        setshowNote(true);
      }
      settransporter(data.length);
    }, [data]);

    /**
     * Adds a new column to the LSP details.
     * @param {Event} e - click event for add.
     */
    const addColumns = (e) => {
      setSearchText("");
      var transporter_value = transporter + 1;
      settransporter(transporter_value);
      var temp = {
        rank: `L${transporter_value}`,
        rate: "",
        business_share: "",
        transporter: {
          transporter_name: "",
        },
      };
      data.push(temp);
    };

    /**
     * Deletes a column from LSP details.
     * @param {React.MouseEvent} e - click event for delete columns.
     * @param {Object} item - LSP details item to be deleted.
     */
    const deleteColumns = (e, item) => {
      var temp = data;
      var list = [];
      if (temp && temp.length > 0) {
        var rankCounter = 1;
        temp.map((values) => {
          if (values.rank !== item.rank) {
            values.rank = `L${rankCounter++}`;
            list.push(values);
          }
        });
      }
      data.length = 0;
      list.map((items) => {
        data.push(items);
      });
      var transporter_value = transporter - 1;
      settransporter(transporter_value);
    };

    /**
     * Validates the business share for the LSP details.
     * @param {Object} lane - lane data.
     * @returns {boolean} - Indicates whether the business share is valid.
     */
    const validateBusinessShare = (lane) => {
      let flags = false;
      var temp = lane;
      var list = [];
      if (temp && temp.length > 0) {
        temp.map((item) => {
          list.push(parseInt(item.business_share));
        });
      }
      list.map((items) => {
        if (items <= 0) {
          flags = true;
        }
      });
      if (flags) {
        toast.error("Business share cannot be 0");
        return false;
      } else {
        if (list.reduce((a, b) => a + b, 0) === 100) {
          return true;
        } else {
          toast.error("Total Business Share should be equal to 100%");
          return false;
        }
      }
    };

    /**
     * Handles the save click event.
     * @param {Event} e - Save click event.
     */
    const saveClick = (e) => {
      let flags = false;
      if (data.length > 0) {
        data.map((items) => {
          if (items.transporter.transporter_name === "") {
            flags = true;
            toast.error("Please enter transporter name");
            return false;
          }
          if (
            items.rate === "" ||
            items.rate === undefined ||
            items.rate <= 0
          ) {
            flags = true;
            toast.error("Please enter valid rate");
            return false;
          }
        });
        if (validateBusinessShare(data) && !flags) {
          toast.success("Transporter details added");
          if (onClose) {
            onClose();
          } else {
            document.getElementById("close_contactus1")?.click();
          }
        }
      }
    };

    /**
     * Handles the edit transporter name event.
     * @param {Event} e - edit click event.
     * @param {number} index - index of the transporter to be edited.
     */
    const editTransporterName = (e, index) => {
      seteditName(index);
    };

    return (
      <>
        {data.length > 0 ? (
          <>
            {showNote ? (
              <>
                <i
                  style={{ color: "yellow", cursor: "pointer" }}
                  className="fa fa-exclamation-triangle"
                  aria-hidden="true"
                ></i>
                Please Note that the total business share allocation currently
                is <b>{note}%</b>. Kindly make sure that total allocation does
                not exceed 100%.
              </>
            ) : null}
            <div style={{ overflowY: "scroll" }}>
              {readOnly ? (
                <>
                  <div style={{ fontSize: "12px" }}>
                    View the shortlisted transporters business share details
                  </div>
                  <div className="row w-100">
                    {/* Auto Allocation */}
                    <div className="col-md-6">
                      <span className="font-weight-bold">
                        Contract Tenure:{" "}
                      </span>
                      <span>
                        {FreightItem?.contract_tenure
                          ? FreightItem.contract_tenure
                          : "NA"}
                      </span>
                    </div>

                    {/* Auto Allocation */}
                    <div className="col-md-5">
                      <span className="font-weight-bold">
                        Total truck loads:{" "}
                      </span>
                      <span>
                        {FreightItem?.truck_load
                          ? FreightItem.truck_load
                          : "NA"}
                      </span>
                    </div>
                  </div>
                </>
              ) : null}
              {data.map((item, index) => (
                <>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: isMobile() ? "column" : "row",
                    }}
                    key={index}
                  >
                    <td
                      style={{
                        width: "100%",
                        marginLeft: "0%",
                        marginRight: "0%",
                      }}
                    >
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>
                          {item.rank} Transporter{" "}
                          {!readOnly && editName !== index ? (
                            <i
                              onClick={(e) => editTransporterName(e, index)}
                              style={{ cursor: "pointer" }}
                              className="fa fa-pencil"
                            ></i>
                          ) : null}
                        </b>
                      </label>
                      <br />
                      <label>
                        {readOnly ? (
                          <>
                            {/* {item.transporter.transporter_name} */}
                            <ProfileModal
                              // transporter_list={dashboard_data.not_quoted_trans_list}
                              transporter_id={item.transporter.transporter_id}
                              transporter_name={
                                item.transporter.transporter_name
                              }
                              screenName="Freight Master"
                              moduleName="masters"
                            />
                          </>
                        ) : item.transporter.transporter_name === "" ? (
                          <Autosuggestor
                            value={searchText}
                            onChange={(e) => setSearchText(e)}
                            onSelect={(e) => setSearchText(e)}
                            getResults={(e) =>
                              inputHandler(e, item, "transporter", allValue)
                            }
                          />
                        ) : editName !== index ? (
                          <input
                            disabled
                            value={item.transporter.transporter_name}
                          />
                        ) : (
                          <Autosuggestor
                            placeholder={item.transporter.transporter_name}
                            value={existingSearchText}
                            onChange={(e) => setexistingSearchText(e)}
                            onSelect={(e) => setexistingSearchText(e)}
                            getResults={(e) =>
                              inputHandler(e, item, "transporter", allValue)
                            }
                          />
                        )}
                      </label>
                    </td>

                    <td
                      style={{
                        width: "100%",
                        marginLeft: "0%",
                        marginRight: "0%",
                      }}
                    >
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>{item.rank} Rate</b>
                      </label>
                      <br />
                      <label>
                        {readOnly ? (
                          <>{item.rate}</>
                        ) : (
                          <input
                            type="number"
                            name="rate"
                            id="rate"
                            onChange={(e) =>
                              inputHandler(
                                e.target.value,
                                item,
                                "rate",
                                allValue
                              )
                            }
                            defaultValue={item.rate}
                          />
                        )}
                      </label>
                    </td>

                    <td
                      style={{
                        width: "100%",
                        marginLeft: "0%",
                        marginRight: "0%",
                      }}
                    >
                      <label style={{ fontWeight: "unset", fontSize: "14px" }}>
                        <b>{item.rank} % Business Share</b>
                      </label>
                      <br />
                      <label>
                        {readOnly ? (
                          <>{item.business_share}</>
                        ) : (
                          <input
                            type="number"
                            name="business_share"
                            id="business_share"
                            onChange={(e) =>
                              inputHandler(
                                e.target.value,
                                item,
                                "business_share",
                                allValue
                              )
                            }
                            defaultValue={item.business_share}
                          />
                        )}
                      </label>
                      {!readOnly ? (
                        <i
                          onClick={(e) => deleteColumns(e, item)}
                          style={{ color: "red", cursor: "pointer" }}
                          className="fa fa-times"
                        ></i>
                      ) : null}
                    </td>
                    {readOnly ? (
                      <td
                        style={{
                          width: "100%",
                          marginLeft: "0%",
                          marginRight: "1%",
                        }}
                      >
                        <label
                          style={{ fontWeight: "unset", fontSize: "14px" }}
                        >
                          <b>Trucks Placed for {item.rank}</b>
                        </label>
                        <br />
                        <label>
                          <>
                            {item?.allocated_truck ? item.allocated_truck : 0}
                          </>
                        </label>
                      </td>
                    ) : null}
                  </div>
                  <hr />
                </>
              ))}
            </div>

            {!readOnly ? (
              <>
                <div className="row col-md-12">
                  <button
                    className="btn btn-sm btn-success"
                    onClick={(e) => addColumns(e)}
                  >
                    <i
                      className="fa fa-plus"
                      style={{ cursor: "pointer", color: "white" }}
                    ></i>
                  </button>
                  {/* <button className="btn btn-sm btn-success" style={{ marginLeft: '43%' }} 
                             onClick={e => saveClick(e)}
                             >
                             Save
                         </button> */}
                </div>
              </>
            ) : null}
          </>
        ) : null}
        {!readOnly && data.length === 0 ? (
          <>
            <div className="row col-md-12">
              <button
                className="btn btn-sm btn-success"
                onClick={(e) => addColumns(e)}
              >
                <i
                  className="fa fa-plus"
                  style={{ cursor: "pointer", color: "white" }}
                ></i>
              </button>
            </div>
          </>
        ) : null}
      </>
    );
  };

  /**
   * Handles input changes for a specific item and updates the state.
   * @param {Event} e - The event object containing the new value.
   * @param {Object} item - The item to be updated.
   * @param {string} name - Property name of item to be updated.
   */
  const newInputHandler = (e, item, name) => {
    if (!dump_ids.includes(item.freightid) && isEdit) {
      setdump_ids([...dump_ids, item.freightid]);
    }
    item[name] = e;
  };

  /**
   * Updates the input text for origin fields at a specific index.
   * @param {string} e - new input value.
   * @param {number} index - index of the input field to be updated.
   */
  const setInputHandler = (e, index) => {
    // if (!dump_ids.includes(item.freightid) && isEdit) {
    //     setdump_ids([...dump_ids, item.freightid])
    // }
    var temp = newInputOriginText.slice();
    temp[index] = e;
    setnewInputOriginText(temp);
  };

  /**
   * Updates the origin value for a specific item and index.
   * @param {string} e - new origin value.
   * @param {number} index - index of the input field to be updated.
   * @param {Object} item - item object to be updated.
   */
  const setnewInputHandler = (e, index, item) => {
    if (!dump_ids.includes(item.freightid) && isEdit) {
      setdump_ids([...dump_ids, item.freightid]);
    }
    item.origin = e;
    var temp = newInputOrigin;
    temp[index] = e;
    setnewInputOrigin(temp);
  };

  /**
   * Updates the input text for destination fields at a specific index.
   * @param {string} e - new input value.
   * @param {number} index - index of the input field to be updated.
   */
  const setdestinationInputHandler = (e, index) => {
    // if (!dump_ids.includes(item.freightid) && isEdit) {
    //     setdump_ids([...dump_ids, item.freightid])
    // }
    var temp = newInputDestinationText.slice();
    temp[index] = e;
    setnewInputDestinationText(temp);
  };

  /**
   * Updates the destination value for a specific item and index.
   * @param {string} e - The new destination value.
   * @param {number} index - The index of the input field to be updated.
   * @param {Object} item - The item object to be updated.
   */
  const setdestinationnewInputHandler = (e, index, item) => {
    if (!dump_ids.includes(item.freightid) && isEdit) {
      setdump_ids([...dump_ids, item.freightid]);
    }
    item.destination = e;
    var temp = newInputDestination;
    temp[index] = e;
    setnewInputDestination(temp);
  };

  /**
   * Handles the change of truck type for a specific item and index.
   * @param {string} value - The new truck type value.
   * @param {Object} item - The item object to be updated.
   * @param {number} index - The index of the input field to be updated.
   */
  const onChangeTruckType = (value, item, index) => {
    if (!dump_ids.includes(item.freightid) && isEdit) {
      setdump_ids([...dump_ids, item.freightid]);
    }
    item.truck_type = value;
    var temp = newinputTrucks;
    temp[index] = value;
    setnewinputTrucks(temp);
  };

  /**
   * Handles changes to other input fields for a specific item.
   * @param {Event} e - The event object containing the new value.
   * @param {Object} item - The item object to be updated.
   */
  const newinputotherHandler = (e, item) => {
    if (!dump_ids.includes(item.freightid) && isEdit) {
      setdump_ids([...dump_ids, item.freightid]);
    }
    item[e.target.id] = e.target.value;
  };

  /**
   * Validates the business share details of lanes.
   * @param {Array<Object>} lanes - list of lanes to validate.
   * @returns {boolean} True if all business shares are valid, false otherwise.
   */
  const isBusinessShareOkay = (lanes) => {
    var not100 = [];
    if (lanes && lanes.length > 0) {
      lanes.map((item) => {
        var list = [];
        if (item.transporter_details && item?.transporter_details?.length > 0) {
          item.transporter_details.map((data) => {
            list.push(parseInt(data.business_share));
          });
        }
        if (list.reduce((a, b) => a + b, 0) !== 100) {
          // console.log(list)
          not100.push(list);
        }
      });
    }
    if (not100.length === 0) {
      return true;
    } else {
      return false;
    }
  };
  /**
    * Submits the lane data.
    * @param {Event} e - submit event object.
    */
  const SubmitLane = (e) => {
    Activity([
      {
        screen: "Company Profile",
        module: "Freight Master",
        user_activity: `Save Button clicked`,
        timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
        , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
      },
    ]);

    TrackMixPanel({
      moduleName: "masters",
      screenName: "freight master",
      definition: "user clicked on edit view save button",
      data: `isEdit mode: ${isEdit ? 'true' : 'false'}, lanes to process: ${newInput.length}`,
    });
    // --------------------------------------------------------------------

    // if (newInput.length === 0) {
    //     toast.info("Please Add lanes first")
    //     TrackMixPanel({
    //       moduleName: "masters",
    //       screenName: "freight master",
    //       definition: "lane submission prevented: no lanes added",
    //       data: `newInput length: 0`,
    //     });
    // }
    // else {
    // if (isEdit) {
    var list = [];
    var temp = newInput;
    if (temp && temp.length > 0) {
      // console.log(temp, 'temp')
      temp.map((item) => {
        if (dump_ids.includes(item.freightid)) {
          list.push(item);
        }
      });
    }
    var lanes = list;
    // console.log(lanes, '1030')
    //     if (isBusinessShareOkay(lanes)) {
    //         axios.put(`${Urls.freight_master}?action=edit_freight_master`, {
    //             lanes
    //         })
    //             .then(res => {
    //                 // console.log(res.data)
    //                 toast.success("Lane submitted succesfully")
    //                 setnewInput([])
    //                 getFreightData()
    //                 setisEdit(false)
    //                 TrackMixPanel({
    //                   moduleName: "masters",
    //                   screenName: "freight master",
    //                   definition: "multiple existing lanes updated successfully",
    //                   data: `lanes updated: ${lanes.length}`,
    //                 });
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 TrackMixPanel({
    //                   moduleName: "masters",
    //                   screenName: "freight master",
    //                   definition: "multiple existing lanes update failed (api call)",
    //                   data: `lanes attempted: ${lanes.length}, error: ${err?.message}`,
    //                 });
    //             })
    //         // toast.success("Data submitted")
    //     }
    //     else {
    //         toast.error("Total Business Share should be equal to 100%")
    //         TrackMixPanel({
    //           moduleName: "masters",
    //           screenName: "freight master",
    //           definition: "multiple existing lanes update failed: business share is not 100%",
    //           data: `lanes attempted: ${lanes.length}`,
    //         });
    //     }
    // }
    // else {
    //     var lanes = newInput
    //     if (isBusinessShareOkay(lanes)) {
    //         axios.post(`${Urls.freight_master}`, {
    //             lanes
    //         })
    //             .then(res => {
    //                 // console.log(res.data)
    //                 toast.success("Lane submitted succesfully")
    //                 setnewInput([])
    //                 getFreightData()
    //                 TrackMixPanel({
    //                   moduleName: "masters",
    //                   screenName: "freight master",
    //                   definition: "multiple new lanes created successfully",
    //                   data: `lanes created: ${lanes.length}`,
    //                 });
    //             })
    //             .catch(err => {
    //                 console.log(err)
    //                 TrackMixPanel({
    //                   moduleName: "masters",
    //                   screenName: "freight master",
    //                   definition: "multiple new lanes creation failed (api call)",
    //                   data: `lanes attempted: ${lanes.length}, error: ${err?.message}`,
    //                 });
    //             })
    //         // toast.success("Data submitted")
    //     }
    //     else {
    //         toast.error("Total Business Share should be equal to 100%")
    //         TrackMixPanel({
    //           moduleName: "masters",
    //           screenName: "freight master",
    //           definition: "multiple new lanes creation failed: business share is not 100%",
    //           data: `lanes attempted: ${lanes.length}`,
    //         });
    //     }
    // }
    // }
  };
  /**
   * Deletes a specific item from the freight data.
   * @param {Event} e -  delete event object.
   * @param {Object} item - item to be deleted.
   */
  const deleteHandler = (e, item) => {
    var temp = freightData;
    var list = [];
    if (temp && temp.length > 0) {
      temp.map((data) => {
        if (data !== item) {
          list.push(data);
        }
      });
    }
    if (window.confirm("Are you sure you want to delete lane/s?")) {
      TrackMixPanel({
        moduleName: "masters",
        screenName: "freight master",
        definition: "user clicked on delete lane button",
        data: `deleted lane - origin: ${item?.origin?.location_name ? item.origin.location_name : "none"
          }, destination: ${item?.destination?.location_name
            ? item.destination.location_name
            : "none"
          }, truck type: ${item?.truck_type?.label ? item.truck_type.label : "none"
          }`,
      });
      // --------------------------------------------------------------------

      setshow(true);
      axios
        .put(
          `${Urls.freight_master}?action=deleted_freight_rate&freightid=${item.freightid}`,
          {}
        )
        .then((res) => {
          toast.success("Lane deleted successfully");
          sendMailToMasters(
            "Freight Master",
            emailTemplate,
            superAdmins,
            {
              action: "Lane Deleted",
              lane: item,
            },
            setshow,
            userDetails?.user_name || userDetails?.email?.split("@")[0]
          );

          var activity = [
            {
              freightid: item.freightid,
              laneid: item.laneid,
            },
          ];
          MastersChangeLog(
            "Line Item Deleted",
            "freight_master",
            userDetails?.email,
            userDetails?.user_id,
            companyProfile?.domain_data?.company_id,
            activity,
            remark
          );
          setshow(false);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Error deleting lane");
          setshow(false);
        });
      setfreightData(list);
    }
  };
  /**
   * Validates the business share details of a lane.
   * @param {Object} lane - lane object containing transporter details.
   * @returns {boolean} True if business shares are valid, false otherwise.
   */
  const validateBusinessShare = (lane) => {
    let flags = false;
    var temp = lane.transporter_details;
    var list = [];
    if (temp && temp.length > 0) {
      temp.map((item) => {
        list.push(parseInt(item.business_share));
      });
    }
    list.map((items) => {
      if (items <= 0) {
        flags = true;
      }
    });
    if (flags) {
      toast.error("Business share cannot be 0");
      return false;
    } else {
      if (list.reduce((a, b) => a + b, 0) === 100) {
        return true;
      } else {
        toast.error("Total Business Share should be equal to 100%");
        return false;
      }
    }
  };

  /**
   * Renders a form for editing a freight master.
   * @param {Object} freightMaster - freight master object to be edited.
   * @param {number} index - index of the freight master in the list.
   * @param {Object} userDetails - details of the user performing the edit.
   * @returns {JSX.Element}
   */
  const EditFreightMaster = ({ freightMaster, index, userDetails }) => {
    const [prevData, setPrevData] = useState({});

    // useefect for deep cloning freight master data
    useEffect(() => {
      var temp = _.cloneDeep(freightMaster);
      setPrevData(temp);
    }, [freightMaster]);

    /**
       * Handles save for the edited freight master.
       * @param {Object} freightMaster - updated freight master object.
       */
    const handleEditSave = (freightMaster) => {
      const isValidNumber = (value) => {
        // Check if value is a non-empty string and matches the number pattern (integer or decimal, with optional negative sign)
        const isValid = /^-?\d+(\.\d+)?$/;
        // Check if the value is not an empty string and matches the regex for valid number
        return !/[a-zA-Z]/.test(value) && isValid?.test(value);
      };
      if (
        freightMaster.market_rate &&
        !isValidNumber(freightMaster.market_rate)
      ) {
        toast.error("Please enter valid market rate");
        return;
      }
      if (freightMaster?.site_rate && !isValidNumber(freightMaster.site_rate)) {
        toast.error("Please enter valid site rate");
        return;
      }
      if (
        freightMaster?.challenge_price &&
        !isValidNumber(freightMaster.challenge_price)
      ) {
        toast.error("Please enter valid challenge price");
        return;
      }
      var editfreightMaster = {
        // organization_id: selectedOrg === "company" ? undefined : selectedOrg,
        company_id: freightMaster.company_id,
        company_name: freightMaster.company_name,
        created_on: freightMaster.created_on,
        doc_type: freightMaster.doc_type ? freightMaster.doc_type : "",
        domain: freightMaster.domain ? freightMaster.domain : "",
        email: freightMaster.email,
        freight_status: freightMaster.freight_status,
        freightid: freightMaster.freightid,
        good_type: freightMaster.good_type ? freightMaster.good_type : "",
        lane_type: freightMaster.lane_type ? freightMaster.lane_type : "",
        laneid: freightMaster.laneid,

        //Auto Allocation
        transporter_details: addTotalTruckAllocation(
          freightMaster.transporter_details,
          freightMaster.truck_load
        ),
        truck_type_group: freightMaster.truck_type_group,
        user_id: freightMaster.user_id,
        origin: freightMaster.origin,
        destination: freightMaster.destination,
        truck_type: freightMaster.truck_type,
        volume: freightMaster.volume ? freightMaster.volume : "",
        transit_time: freightMaster.transit_time
          ? freightMaster.transit_time
          : "",
        distance: freightMaster.distance ? freightMaster.distance : "",
        unit: freightMaster.unit ? freightMaster.unit : "",
        zone: freightMaster.zone ? freightMaster.zone : "",
        route_code: freightMaster.route_code ? freightMaster.route_code : "",

        //auto allocation
        contract_tenure: freightMaster.contract_tenure ?? "",
        market_rate: freightMaster.market_rate
          ? parseInt(freightMaster.market_rate)
          : 0,
        site_rate: freightMaster.site_rate
          ? parseInt(freightMaster.site_rate)
          : 0,
        challenge_price: freightMaster.challenge_price
          ? parseInt(freightMaster.challenge_price)
          : 0,
        truck_load: freightMaster.truck_load ?? "",
        baseline_rate: parseInt(freightMaster.baseline_rate) ?? 0,
      };
      const updated_data = findObjectDifferences(prevData, editfreightMaster);
      const previous_data = getCommonKeys(prevData, updated_data);
      var list = freightData.map((list, idx) => {
        if (index === idx) {
          list = editfreightMaster;
        }
        return list;
      });
      let flags = false;
      var transportersName;
      if (freightMaster?.transporter_details?.length > 0) {
        freightMaster.transporter_details.map((items) => {
          if (items.transporter.transporter_name === "") {
            flags = true;
            toast.error("Please enter transporter name");
            return false;
          }
          if (
            items.rate === "" ||
            items.rate === undefined ||
            items.rate <= 0
          ) {
            flags = true;
            toast.error("Please enter valid rate");
            return false;
          } else {
            transportersName = items.transporter.transporter_name;
          }
        });
        if (validateBusinessShare(freightMaster) && !flags) {
          Activity([
            {
              screen: "masters",
              module: "Freight Master",
              user_activity: `Save Button clicked`,
              timestamp: currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name
              , companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : ""
            },
          ]);
          TrackMixPanel({
            moduleName: "masters",
            screenName: "freight master",
            definition: "user clicked on edit modal save button",
            data: `transporters: ${transportersName}, lane: ${freightMaster?.origin?.location_name
              } to ${freightMaster?.destination?.location_name
              }, truck type: ${freightMaster?.truck_type?.label
              }, volume: ${freightMaster?.volume}, transit time: ${freightMaster?.transit_time}`,
          });
          freightMaster.transporter_details.map((items) => {
            items.business_share = parseFloat(items.business_share);
            items.rate = parseFloat(items.rate);
          });
          var lanes = [editfreightMaster];
          axios
            .put(`${Urls.freight_master}?action=edit_freight_master`, {
              lanes,
            })
            .then((res) => {
              toast.success("Lane submitted succesfully");
              sendMailToMasters("Freight Master", emailTemplate, superAdmins,
                {
                  action: "Lane Edited",
                  lane: editfreightMaster
                }
                , setshow, userDetails?.user_name || userDetails?.email?.split("@")[0]
              )
              document.getElementById("edit_freight_master_close_btn").click();
              // getFreightData(skipactive);
              var activity = {
                freightid: editfreightMaster.freightid,
                laneid: editfreightMaster.laneid,
                existing_data: previous_data,
                updated_data: updated_data,
              };
              // calling change log api to track edits
              MastersChangeLog(
                "Line Item Updated",
                "freight_master",
                userDetails?.email,
                userDetails?.user_id,
                companyProfile?.domain_data?.company_id,
                activity,
                ""
              );
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } else {
        toast.error("Please Enter atleast 1 Transporter");
        return false;
      }
    };

    return (
      <>
        <div className={`row m-0`}>
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Origin</span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={freightMaster.origin.location_name}
              />
            </label>
          </div>
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Origin ID</span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={
                  freightMaster?.origin?.location_code
                    ? freightMaster.origin.location_code
                    : "-"
                }
              />
            </label>
          </div>
          {/* <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>Origin State</span>
                        <label style={{ width: '100%' }}>
                            <input disabled='true'  type="text" style={{ height: '37px' }} defaultValue={ locationMaster.origin.location.state} />
                        </label>
                    </div> */}
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Destination</span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={freightMaster.destination.location_name}
              />
            </label>
          </div>
          <div className={"col-md-3"}>
            <span style={{ fontWeight: "600" }}>Destination ID</span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={
                  freightMaster?.destination?.location_code
                    ? freightMaster.destination.location_code
                    : "-"
                }
              />
            </label>
          </div>
          {/* <div className={'col-md-3'}>
                        <span style={{ fontWeight: '600' }}>destination State</span>
                        <label style={{ width: '100%' }}>
                            <input disabled='true'  type="text" style={{ height: '37px' }} defaultValue={locationMaster.destination.location.state} />
                        </label>
                        </div> */}
          <div className={`row m-0`}>
            <div className={"col-md-3"}>
              <div>
                <span style={{ fontWeight: "600" }}>Truck Type</span>
                <label style={{ width: "100%" }}>
                  {/* <Select
                                    options={TruckTypes}
                                    isMulti={false}
                                    onChange={e => setTrucktype(e.value)}
                                    // value={truck_name}
                                    className={"Truck_Type_Select"}
                                    classNamePrefix={"Truck_Prefix"}
                                    defaultValue=""
                                    /> */}
                  <input
                    disabled="true"
                    type="text"
                    style={{ height: "37px", cursor: "no-drop" }}
                    defaultValue={freightMaster.truck_type.label}
                  />
                </label>
              </div>
            </div>
            <div className={"col-md-2"}>
              <span style={{ fontWeight: "600" }}>Volume</span>
              <label style={{ width: "100%" }}>
                <input
                  type="number"
                  style={{ height: "37px" }}
                  onChange={(e) => {
                    freightMaster.volume = Number(e.target.value);
                  }}
                  defaultValue={freightMaster.volume}
                />
              </label>
            </div>

            <div className={"col-md-2"}>
              <span style={{ fontWeight: "600" }}>Transit Time</span>
              <label style={{ width: "100%" }}>
                <input
                  type="number"
                  style={{ height: "37px" }}
                  onChange={(e) => {
                    freightMaster.transit_time = Number(e.target.value);
                  }}
                  defaultValue={freightMaster.transit_time}
                />
              </label>
            </div>
            <div className={"col-md-2"}>
              <span style={{ fontWeight: "600" }}>Distance</span>
              <label style={{ width: "100%" }}>
                <input
                  type="number"
                  style={{ height: "37px" }}
                  onChange={(e) => {
                    freightMaster.distance = Number(e.target.value);
                  }}
                  defaultValue={freightMaster.distance}
                />
              </label>
            </div>
            <div className={"col-md-2"}>
              <span style={{ fontWeight: "600" }}>Unit</span>
              <label style={{ width: "100%" }}>
                <Select
                  options={[
                    { value: "MT", label: "MT" },
                    { value: "KG", label: "KG" },
                  ]}
                  isMulti={false}
                  onChange={(e) => {
                    freightMaster.unit = e.value;
                  }}
                  className={"Truck_Type_Select"}
                  classNamePrefix={"Truck_Prefix"}
                  defaultValue={freightMaster.unit}
                  placeholder={
                    freightMaster.unit ? freightMaster.unit : "Select.."
                  }
                  isSearchable={false}
                />
              </label>
            </div>
          </div>
        </div>
        <div className="row m-2">
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Zone</span>
            <label style={{ width: "100%" }}>
              <input
                type="text"
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.zone = e.target.value;
                }}
                defaultValue={freightMaster.zone}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Route Code</span>
            <label style={{ width: "100%" }}>
              <input
                disabled="true"
                type="text"
                style={{ height: "37px", cursor: "no-drop" }}
                defaultValue={freightMaster.route_code}
              />
            </label>
          </div>
          {/* Auto allocation fields */}
          <div className={"col-md-4"}>
            <span style={{ fontWeight: "600" }}>Contract Tenure</span>
            <label style={{ width: "100%" }}>
              {/* <input disabled='true' type="text" style={{ height: '37px' , cursor:'no-drop'}} defaultValue={freightMaster.contract_tenure} /> */}
              <select
                className="form-control"
                defaultValue={freightMaster.contract_tenure}
                onChange={(e) =>
                  (freightMaster.contract_tenure = e.target.value)
                }
              >
                <option hidden>Select contract tenure</option>
                <option value="Annual">Annual</option>
                <option value="Semi-annual">Semi Annual</option>
                <option value="Monthly">Monthly</option>
                <option value="Weekly">Weekly</option>
              </select>
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Truck Load</span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.truck_load = e.target.value;
                }}
                defaultValue={freightMaster.truck_load}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Baseline Rate</span>
            <label style={{ width: "100%" }}>
              <input
                type="number"
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.baseline_rate = e.target.value;
                }}
                defaultValue={freightMaster.baseline_rate}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Market Rate</span>
            <label style={{ width: "100%" }}>
              <input
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.market_rate = e.target.value;
                }}
                defaultValue={freightMaster.market_rate}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600" }}>Site Rate</span>
            <label style={{ width: "100%" }}>
              <input
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.site_rate = e.target.value;
                }}
                defaultValue={freightMaster.site_rate}
              />
            </label>
          </div>
          <div className={"col-md-2"}>
            <span style={{ fontWeight: "600", textWrap: "nowrap" }}>
              Challenge Price
            </span>
            <label style={{ width: "100%" }}>
              <input
                style={{ height: "37px" }}
                onChange={(e) => {
                  freightMaster.challenge_price = e.target.value;
                }}
                defaultValue={freightMaster.challenge_price}
              />
            </label>
          </div>
        </div>
        <div>
          <span className="ml-4" style={{ fontWeight: "600" }}>
            Add Transporters
          </span>
          <ViewLspDetails
            allValue={freightMaster}
            data={freightMaster.transporter_details}
          />
        </div>
        <div className={`text-center`}>
          <button
            className={`${classes["save-btn"]} btn btn-success`}
            onClick={() => handleEditSave(freightMaster)}
          >
            Save
          </button>
        </div>
      </>
    );
  };

  const getOnChange = (e) => {
    setSkipactive(e);
    if (isFilterActive && filterPayload) {
      const currentLimit = filterPayload?.pagination?.limit || 500;
      const dynamicSkip = (e - 1) * currentLimit;
      const updatedPayload = {
        ...filterPayload,
        pagination: {
          ...filterPayload.pagination,
          skip: dynamicSkip,
          limit: currentLimit
        }
      };
      setFilterPayload(updatedPayload);
      handleFilterApply(updatedPayload, false);
    } else {
      const calculatedSkip = (e - 1) * 500;
      getFreightData(calculatedSkip);
    }
  };

  return (
    <div>
      <Loader show={show} />
      <div>
        <div>{!isEdit ? <AddNewLane /> : null}</div>
      </div>
      {filtersshown && (
        <div className="mt-4 mb-4">
          <MultiSelectFilterUI
            module="FreightMaster"
            action="filterable_fields"
            defaultFields={[
              { key: 'origin_city', label: 'Origin City', type: 'text' },
              { key: 'destination_city', label: 'Destination City', type: 'text' },
              { key: 'truck_type', label: 'Truck Type', type: 'enum' }
            ]}
            defaultSortOptions={DEFAULT_SORT_OPTIONS}
            onFilterApply={handleFilterApply}
            onReset={handleFilterReset}
            initialPayload={filterPayload}
            isLoading={isFilterLoading || show}
            onClose={() => setfiltershown(false)}
            showSearch={false}
          />
        </div>
      )}
      <ActiveFilterPills />
      <div>
        {freightData && freightData.length > 0 ? (
          <>
            <div>
              <div className="row m-0 w-100">
                <div className={isMobile() ? "col-12 p-0" : `col-12 p-0 ${classes["colhead1"]}`}>
                  {isMobile() ? (
                    <div>
                      {freightData.map((item, index) => (
                        <div
                          key={index}
                          style={{
                            padding: "1%",
                            margin: "1%",
                            borderRadius: "5px",
                            border: "1px solid lightgrey",
                          }}
                        >
                          <div>
                            <b>Origin: </b>
                            {item.origin.location_name.split(",")[0]}
                          </div>
                          <div>
                            <b>Origin State: </b>
                            {
                              item.origin.location_name.split(",")[
                              item.origin.location_name.split(",").length - 1
                              ]
                            }
                          </div>
                          <div>
                            <b>Destination: </b>
                            {item.destination.location_name.split(",")[0]}
                          </div>
                          <div>
                            <b>Destination State: </b>
                            {
                              item.destination.location_name.split(",")[
                              item.destination.location_name.split(",")
                                .length - 1
                              ]
                            }
                          </div>
                          <div>
                            <b>Truck Type: </b>
                            {item.truck_type ? item.truck_type.value : null}
                          </div>
                          <div>
                            <b>Volume: </b>
                            {item.volume ? item.volume : ""}
                          </div>
                          <div>
                            <b>Transit Time: </b>
                            {item.transit_time ? item.transit_time : ""}
                          </div>
                          <div>
                            <b>Unit: </b>
                            {item.unit ? item.unit : ""}
                          </div>
                          <div>
                            <b>Zone: </b>
                            {item.zone ? item.zone : ""}
                          </div>
                          <div>
                            <b>Route: </b>
                            {item.route_code ? item.route_code : ""}
                          </div>
                          <div>
                            <b>Route: </b>
                            {item.baseline_rate ? item.baseline_rate : ""}
                          </div>
                          <div>
                            <label style={{ width: "90%" }}>
                              <Modal
                                buttonLabel={
                                  <span
                                    style={{
                                      fontSize: "14px",
                                      textDecoration: "underline",
                                      color: "#393185",
                                    }}
                                  >
                                    View Transporter Details
                                  </span>
                                }
                                buttonClass="btn btn-link"
                                content={({ onClose }) => (
                                  <ViewLspDetails
                                    readOnly={true}
                                    data={item.transporter_details}
                                    onClose={onClose}
                                  />
                                )}
                                title={`Shortlist Transporters`}
                                id="view_lsp_details_btn_dashboard"
                                screenName="masters"
                                moduleName="Freight Master"
                                activityName="Freight Master - View Transporters button clicked"
                                backdrop={true}
                              />
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className={`${classes["TruckContainer"]}`}>
                      <table
                        className={`table table-borderless ${classes["table-width"]}`}
                      >
                        <thead className={`${classes["sticky-header"]}`}>
                          <tr
                            style={{
                              fontSize: "13px",
                              textAlignLast: "center",
                            }}
                            className={`text-nowrap ${classes["sticky-th"]}`}
                          >
                            <th scope="col">
                              <input
                                type="checkbox"
                                checked={
                                  freightData &&
                                  freightData.length > 0 &&
                                  deletion_list.length === freightData.length
                                }
                                onChange={selectAllHandler}
                                style={{ width: "15px", height: "15px" }}
                              />
                            </th>
                            <th scope="col" style={{ width: "8%" }}>
                              Sr.No.
                            </th>
                            <th scope="col">Origin</th>
                            <th scope="col">Origin ID</th>
                            <th scope="col">Origin State</th>
                            <th scope="col">Destination</th>
                            <th scope="col">Destination ID</th>
                            <th scope="col">Destination State</th>
                            <th scope="col">Truck Types</th>
                            <th scope="col">Volume</th>
                            <th scope="col" className="text-center">
                              Transit Time
                            </th>
                            <th scope="col">Distance</th>
                            <th scope="col">Unit</th>
                            <th scope="col">Zone</th>
                            <th scope="col">Route Code</th>
                            <th scope="col">Baseline Rate</th>
                            <th scope="col">Market Rate</th>
                            <th scope="col">Site Rate</th>
                            <th scope="col">Challenge Price</th>
                            <th scope="col">Transporters</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {freightData && freightData.length > 0
                            ? freightData.map((item, index) => (
                              <tr
                                key={`lane_${index}`}
                                style={{ fontSize: "12px" }}
                              >
                                <td>
                                  <input
                                    type="checkbox"
                                    style={{ width: "15px", height: "15px" }}
                                    onChange={(e) =>
                                      checkboxeshandler(e, item)
                                    }
                                    checked={deletion_list.some(
                                      (deleteItem) =>
                                        deleteItem.freightid ===
                                        item.freightid
                                    )}
                                  />
                                </td>
                                <td scope="col">
                                  {
                                    ((skipactive === 0 ? 1 : skipactive) - 1) * (filterPayload?.pagination?.limit || 500) +
                                    index +
                                    1
                                  }
                                </td>
                                <td scope="col" style={{ width: "8%" }}>
                                  {item?.origin?.location?.label ?? "-"}
                                </td>
                                <td scope="col">
                                  {item.origin?.location_code
                                    ? item.origin.location_code
                                    : "-"}
                                </td>
                                <td scope="col">
                                  {item?.origin?.location?.state ?? ""}
                                </td>
                                <td scope="col">
                                  {item?.destination?.location?.label ?? ""}{" "}
                                </td>
                                <td scope="col">
                                  {item.destination?.location_code
                                    ? item.destination.location_code
                                    : "-"}
                                </td>
                                <td scope="col">
                                  {item?.destination?.location?.state ?? ""}
                                </td>
                                <td scope="col">
                                  {item.truck_type
                                    ? item.truck_type.value
                                    : null}
                                </td>
                                <td scope="col">
                                  {item.volume ? item.volume : ""}
                                </td>
                                <td scope="col">
                                  {item.transit_time
                                    ? parseFloat(item.transit_time).toFixed(2)
                                    : ""}
                                </td>
                                <td scope="col">
                                  {item.distance
                                    ? parseFloat(item.distance).toFixed(2)
                                    : ""}
                                </td>
                                <td scope="col">
                                  {item.unit ? item.unit : ""}
                                </td>
                                <td scope="col">
                                  {item.zone ? item.zone : ""}
                                </td>
                                <td scope="col">
                                  {item.route_code ? item.route_code : ""}
                                </td>
                                <td scope="col">
                                  {item.baseline_rate
                                    ? item.baseline_rate
                                    : ""}
                                </td>
                                <td scope="col">
                                  {item.market_rate ? item.market_rate : "-"}
                                </td>
                                <td scope="col">
                                  {item.site_rate ? item.site_rate : "-"}
                                </td>
                                <td scope="col">
                                  {item.challenge_price
                                    ? item.challenge_price
                                    : "-"}
                                </td>
                                <td scope="col">
                                  <label style={{ width: "30%" }}>
                                    <Modal
                                      buttonLabel={
                                        <span
                                          style={{
                                            fontSize: isMobile()
                                              ? "14px"
                                              : "12px",
                                          }}
                                        >
                                          {<i className="fa fa-eye"></i>}
                                        </span>
                                      }
                                      buttonClass="btn btn-link"
                                      content={({ onClose }) => (
                                        <ViewLspDetails
                                          readOnly={true}
                                          data={item.transporter_details}
                                          FreightItem={item}
                                          onClose={onClose}
                                        />
                                      )}
                                      title={`Shortlisted Transporters`}
                                      id="view_lsp_details_btn_1"
                                      screenName="Company Profile"
                                      moduleName="Freight Master"
                                      activityName="Freight Master - View Transporters button clicked"
                                      backdrop={true}
                                    />
                                  </label>
                                </td>
                                <td>
                                  <div
                                    style={{
                                      marginTop: "10px",
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 9
                                    }}
                                  >
                                    <div style={{ display: 'inline-block' }}>
                                      <Modal
                                        buttonLabel={
                                          <i
                                            className="fa fa-pencil"
                                            aria-hidden="true"
                                          />
                                        }
                                        buttonClass={classes.iconBtn}
                                        disabled={canedit || !canUpdate}
                                        content={
                                          <EditFreightMaster
                                            freightMaster={item}
                                            index={index}
                                            userDetails={userDetails}
                                          />
                                        }
                                        title="Edit Freight Master"
                                        id="freightmaster"
                                        screenName="Company profile"
                                        moduleName="Company profile"
                                        backdrop={false}
                                        closeButtonId="edit_freight_master_close_btn"
                                        onClose={() => {
                                          getFreightData(skipactive);
                                        }}
                                      />
                                    </div>
                                    <button
                                      className="btn btn-link p-0 text-dark"
                                      style={{ border: 'none', background: 'transparent' }}
                                      disabled={canedit || !canUpdate}
                                      onClick={(e) => deleteHandler(e, item)}
                                    >
                                      <i className="fa fa-trash" />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                            : null}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {/* <button id="submitLane" style={{ marginLeft: '50%' }} className="btn btn-success" onClick={e => SubmitLane(e)}>{isEdit ? "Save" : null}</button> */}
              {isEdit ? (
                <button
                  id="submitLane"
                  style={{ marginLeft: "50%" }}
                  className="btn btn-success"
                  onClick={(e) => SubmitLane(e)}
                >
                  Save
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <>
            <div>
              <div className="row m-0 w-100">
                <div className={isMobile() ? "col-12 p-0" : `col-12 p-0 ${classes["colhead1"]}`}>
                  {isMobile() ? (
                    <div>
                      {newInput.length > 0
                        ? newInput.map((item, index) => (
                          <div
                            key={index}
                            style={{
                              border: "1px solid lightgrey",
                              borderRadius: "5px",
                              margin: "1%",
                              padding: "1%",
                            }}
                          >
                            <button
                              onClick={(e) => deleteLane(e, item)}
                              className="btn btn-link"
                              disabled={canedit || !canUpdate}
                              style={{
                                float: "right",
                                color: "#393186",
                                margin: "1%",
                                padding: "1%",
                                border: 'none',
                                background: 'transparent'
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                            <div
                              style={{ display: "flex", marginTop: "10%" }}
                            >
                              <b style={{ flexBasis: "30%" }}>Origin: </b>
                              <label
                                style={{
                                  flexBasis: "70%",
                                  marginBottom: "2%",
                                }}
                              >
                                <Autocomplete
                                  placeholder={
                                    item.origin.location_name.split(",")[0]
                                  }
                                  key={"Origin_Key"}
                                  value={newInputOriginText[index]}
                                  onSelect={(e) =>
                                    setnewInputHandler(e, index, item)
                                  }
                                  onChange={(e) => setInputHandler(e, index)}
                                  getResults={(e) =>
                                    newInputHandler(e, item, "origin")
                                  }
                                  className={classes["originn"]}
                                />
                              </label>
                            </div>
                            <div>
                              <b>Origin State:</b>
                              {
                                item.origin.location_name.split(",")[
                                item.origin.location_name.split(",")
                                  .length - 1
                                ]
                              }
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>
                                Destination:{" "}
                              </b>
                              <label
                                style={{
                                  flexBasis: "70%",
                                  marginBottom: "2%",
                                }}
                              >
                                <Autocomplete
                                  key="Destination_Key"

                                  value={
                                    newInputDestinationText[index]
                                      ? {
                                        label: newInputDestinationText[index],
                                        value: newInputDestinationText[index],
                                      }
                                      : null
                                  }

                                  placeholder={
                                    item.origin.location_name.split(",")[0]
                                  }

                                  onChange={(val) =>
                                    setdestinationInputHandler(val, index)
                                  }

                                  onSelect={(obj) =>
                                    setdestinationnewInputHandler(obj, index, item)
                                  }

                                  className={classes["originn"]}
                                />
                              </label>
                            </div>
                            <div>
                              <b>Destination State:</b>
                              {
                                item.destination.location_name.split(",")[
                                item.destination.location_name.split(",")
                                  .length - 1
                                ]
                              }
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>Truck Type: </b>
                              <label style={{ flexBasis: "70%" }}>
                                <Select
                                  options={TruckTypes}
                                  isMulti={false}
                                  onChange={
                                    (value) =>
                                      onChangeTruckType(value, item, index)
                                    // setselectedTrucks(value)
                                    // onChangeTruckTypes(value)
                                  }
                                  // value={newinputTrucks}
                                  className={"Truck_Type_Select"}
                                  classNamePrefix={"Truck_Prefix"}
                                  defaultValue={item.truck_type}
                                // defaultValue={newinputTrucks}
                                />
                              </label>
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>Volume: </b>
                              <label style={{ flexBasis: "70%" }}>
                                <input
                                  type="number"
                                  name="volume"
                                  id="volume"
                                  onChange={(e) =>
                                    newinputotherHandler(e, item)
                                  }
                                  placeholder={item.volume}
                                />
                              </label>
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>
                                Transit Time:{" "}
                              </b>
                              <label style={{ flexBasis: "70%" }}>
                                <input
                                  type="number"
                                  name="transit_time"
                                  id="transit_time"
                                  onChange={(e) =>
                                    newinputotherHandler(e, item)
                                  }
                                  placeholder={
                                    item?.transit_time ? item?.transit_time : ""
                                  }
                                />
                              </label>
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>Unit</b>
                              <label style={{ flexBasis: "70%" }}>
                                <select
                                  className="form-control"
                                  name="unit"
                                  id="unit"
                                  onChange={(e) =>
                                    newinputotherHandler(e.target.value)
                                  }
                                >
                                  <option
                                    value="MT"
                                    selected={item.unit === "MT"}
                                  >
                                    MT
                                  </option>
                                  <option
                                    value="KG"
                                    selected={item.unit === "KG"}
                                  >
                                    KG
                                  </option>
                                </select>
                              </label>
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>Zone</b>
                              <label style={{ flexBasis: "70%" }}>
                                <input
                                  name="zone"
                                  id="zone"
                                  onChange={(e) =>
                                    newinputotherHandler(e, item)
                                  }
                                  placeholder={item.zone ? item.zone : ""}
                                />
                              </label>
                            </div>
                            <div style={{ display: "flex" }}>
                              <b style={{ flexBasis: "30%" }}>Route Code</b>
                              <label style={{ flexBasis: "70%" }}>
                                <input
                                  name="route_code"
                                  id="route_code"
                                  onChange={(e) =>
                                    newinputotherHandler(e, item)
                                  }
                                  placeholder={
                                    item.route_code ? item.route_code : ""
                                  }
                                />
                              </label>
                            </div>
                            <div>
                              <Modal
                                buttonLabel={
                                  <span
                                    style={{
                                      fontSize: isMobile() ? "14px" : "12px",
                                    }}
                                  >
                                    {isMobile()
                                      ? "Edit transporter details"
                                      : "View details"}
                                  </span>
                                }
                                buttonClass="btn btn-sm btn-link"
                                content={({ onClose }) => (
                                  <ViewLspDetails
                                    allValue={item}
                                    data={item.transporter_details}
                                    onClose={onClose}
                                  />
                                )}
                                title={`Shortlist Transporters`}
                                id="view_lsp_details_btn_mobile_list"
                                screenName="Company Profile"
                                moduleName="12. Freight Master"
                                activityName="12. Freight Master - View Transporters button clicked"
                                backdrop={true}
                              />
                            </div>
                          </div>
                        ))
                        : null}
                    </div>
                  ) : (
                    <table>
                      <tbody>
                        <tr>
                          <th
                            className={`${classes["sr_no"]} ${classes["sticky-th"]}`}
                            style={{ textAlign: "center" }}
                          >
                            Sr.No.
                          </th>
                          <th
                            className={`${classes["oc"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Origin City
                          </th>
                          <th
                            className={`${classes["os"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Origin State
                          </th>
                          <th
                            className={`${classes["dc"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Destination City
                          </th>
                          <th
                            className={`${classes["ds"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Destination State
                          </th>
                          <th
                            className={`${classes["tt"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Truck Types
                          </th>
                          <th
                            className={`${classes["vol"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Volume
                          </th>
                          <th
                            className={`${classes["time"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Transit Time
                          </th>
                          {/* <th className={`${classes['rate']} `} style={{ textAlign: "center" }}>Baseline Rate</th> */}
                          <th
                            className={`${classes["rate"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Unit
                          </th>
                          <th
                            className={`${classes["rate"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Zone
                          </th>
                          <th
                            className={`${classes["rate"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Route Code
                          </th>
                          <th
                            className={`${classes["trans"]} `}
                            style={{ textAlign: "center" }}
                          >
                            Transporters
                          </th>
                          {/* <th className={`${classes['action']} `} style={{ textAlign: "center" }}>Action</th> */}
                        </tr>
                        {newInput.length > 0
                          ? newInput.map((item, index) => (
                            <>
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>
                                  <input
                                    type="checkbox"
                                    style={{ width: "15px", height: "15px" }}
                                    onChange={(e) =>
                                      checkboxeshandler(e, item)
                                    }
                                    checked={deletion_list.includes(
                                      item.freightid
                                    )}
                                  />
                                </td>
                                <td>
                                  <label
                                    style={{
                                      width: "100%",
                                      marginBottom: "2%",
                                    }}
                                  >
                                    <Autocomplete
                                      placeholder={
                                        item.origin.location_name.split(",")[0]
                                      }
                                      key={"Origin_Key"}
                                      value={newInputOriginText[index]}
                                      onSelect={(e) =>
                                        setnewInputHandler(e, index, item)
                                      }
                                      onChange={(e) =>
                                        setInputHandler(e, index)
                                      }
                                      getResults={(e) =>
                                        newInputHandler(e, item, "origin")
                                      }
                                      className={classes["originn"]}
                                    />
                                  </label>
                                </td>
                                <td>
                                  {
                                    item.origin.location_name.split(",")[
                                    item.origin.location_name.split(",")
                                      .length - 1
                                    ]
                                  }
                                </td>
                                <td>
                                  <label
                                    style={{
                                      width: "100%",
                                      marginBottom: "2%",
                                    }}
                                  >
                                    <Autocomplete
                                      key="Destination_Key"

                                      value={
                                        newInputDestinationText[index]
                                          ? {
                                            label: newInputDestinationText[index],
                                            value: newInputDestinationText[index],
                                          }
                                          : null
                                      }

                                      placeholder={
                                        item.origin.location_name.split(",")[0]
                                      }

                                      onChange={(val) =>
                                        setdestinationInputHandler(val, index)
                                      }

                                      onSelect={(obj) =>
                                        setdestinationnewInputHandler(obj, index, item)
                                      }

                                      className={classes["originn"]}
                                    />
                                  </label>
                                </td>
                                <td>
                                  {
                                    item.destination.location_name.split(",")[
                                    item.destination.location_name.split(
                                      ","
                                    ).length - 1
                                    ]
                                  }
                                </td>
                                <td>
                                  <label style={{ width: "100%" }}>
                                    <Select
                                      options={TruckTypes}
                                      isMulti={false}
                                      onChange={
                                        (value) =>
                                          onChangeTruckType(
                                            value,
                                            item,
                                            index
                                          )
                                        // setselectedTrucks(value)
                                        // onChangeTruckTypes(value)
                                      }
                                      // value={newinputTrucks}
                                      className={"Truck_Type_Select"}
                                      classNamePrefix={"Truck_Prefix"}
                                      defaultValue={item.truck_type}
                                    // defaultValue={newinputTrucks}
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <input
                                      type="number"
                                      name="volume"
                                      id="volume"
                                      onChange={(e) =>
                                        newinputotherHandler(e, item)
                                      }
                                      placeholder={item.volume}
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <input
                                      type="number"
                                      name="transit_time"
                                      id="transit_time"
                                      onChange={(e) =>
                                        newinputotherHandler(e, item)
                                      }
                                      placeholder={
                                        item.transit_time
                                          ? item.transit_time
                                          : ""
                                      }
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <select
                                      className="form-control"
                                      name="unit"
                                      id="unit"
                                      onChange={(e) =>
                                        newinputotherHandler(e, item)
                                      }
                                    >
                                      <option
                                        hidden
                                        selected={item.unit === ""}
                                      ></option>
                                      <option
                                        value="MT"
                                        selected={item.unit === "MT"}
                                      >
                                        MT
                                      </option>
                                      <option
                                        value="KG"
                                        selected={item.unit === "KG"}
                                      >
                                        KG
                                      </option>
                                    </select>
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <input
                                      name="zone"
                                      id="zone"
                                      onChange={(e) =>
                                        newinputotherHandler(e, item)
                                      }
                                      placeholder={item.zone ? item.zone : ""}
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <input
                                      name="route_code"
                                      id="route_code"
                                      onChange={(e) =>
                                        newinputotherHandler(e, item)
                                      }
                                      placeholder={
                                        item.route_code ? item.route_code : ""
                                      }
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <Modal
                                      buttonLabel={
                                        <span style={{ fontSize: "12px" }}>
                                          View Details
                                        </span>
                                      }
                                      buttonClass="btn btn-link"
                                      content={({ onClose }) => (
                                        <ViewLspDetails
                                          allValue={item}
                                          data={item.transporter_details}
                                          onClose={onClose}
                                        />
                                      )}
                                      title={`Shortlist Transporters`}
                                      id="view_lsp_details_btn_2"
                                      screenName="Company Profile"
                                      moduleName="12. Freight Master"
                                      activityName="12. Freight Master - View Transporters button clicked"
                                      backdrop={true}
                                    />
                                  </label>
                                </td>
                                <td>
                                  <label style={{ width: "90%" }}>
                                    <button
                                      onClick={(e) => deleteLane(e, item)}
                                      className="btn btn-link"
                                      disabled={canedit || !canUpdate}
                                      style={{
                                        color: "#393186",
                                        padding: 0,
                                        border: 'none',
                                        background: 'transparent'
                                      }}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                  </label>
                                </td>
                              </tr>
                            </>
                          ))
                          : null}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {isEdit ? (
                <>
                  <button
                    id="submitLane"
                    style={{ marginLeft: "50%" }}
                    className="btn btn-success"
                    onClick={(e) => SubmitLane(e)}
                  >
                    Save
                  </button>
                </>
              ) : null}
            </div>
          </>
        )}
      </div>
      <div className="text-center w-100">
        <Pagination
          activePage={skipactive === 0 ? 1 : skipactive}
          itemsCountPerPage={filterPayload?.pagination?.limit || 500}
          totalItemsCount={totalcount}
          onChange={(e) => getOnChange(e)}
          itemClass="page-item"
          linkClass="page-link"
        // hideDisabled
        />
      </div>
    </div>
  );
};

export default FreightMaster;
